(function () {
  var storageKey = "patrick-store-theme";

  function setTheme(theme) {
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
    try {
      localStorage.setItem(storageKey, theme);
    } catch (error) {}
    document.querySelectorAll("[data-theme-choice]").forEach(function (button) {
      var active = button.getAttribute("data-theme-choice") === theme;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function initTheme(scope) {
    var root = scope || document;
    var current = document.documentElement.dataset.theme || "light";
    setTheme(current);
    root.querySelectorAll("[data-theme-choice]").forEach(function (button) {
      if (button.dataset.paThemeReady === "true") return;
      button.dataset.paThemeReady = "true";
      button.addEventListener("click", function () {
        setTheme(button.getAttribute("data-theme-choice"));
      });
    });
  }

  function initExternalVideos(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-external-video-load]").forEach(function (button) {
      if (button.dataset.paExternalVideoReady === "true") return;
      button.dataset.paExternalVideoReady = "true";
      button.addEventListener("click", function () {
        var container = button.closest("[data-external-video]");
        var source = button.getAttribute("data-external-video-src");
        if (!container || !source) return;

        var provider = button.getAttribute("data-external-video-provider") || "external video provider";
        var iframe = document.createElement("iframe");
        iframe.className = "pa-external-video-frame";
        iframe.src = source;
        iframe.title = button.getAttribute("data-external-video-title") || "Video introduction";
        iframe.allow = provider === "YouTube"
          ? "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          : "autoplay; fullscreen; picture-in-picture";
        iframe.referrerPolicy = "strict-origin-when-cross-origin";
        iframe.setAttribute("allowfullscreen", "");
        container.replaceChildren(iframe);
      });
    });
  }

  function initHeader() {
    var root = document.documentElement;
    function syncScrollState() {
      root.classList.toggle("has-scrolled-past-project-banner", window.scrollY > 4);
    }
    syncScrollState();
    window.addEventListener("scroll", syncScrollState, { passive: true });
  }

  var ajaxCart = {
    cart: null,
    request: null
  };

  function cartRootPath() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
    return root.slice(-1) === "/" ? root : root + "/";
  }

  function formatCartMoney(cents) {
    var currency = window.paStoreLocalization && window.paStoreLocalization.currencyIsoCode
      ? window.paStoreLocalization.currencyIsoCode
      : "GBP";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-GB", {
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol"
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return ((Number(cents) || 0) / 100).toFixed(2) + " " + currency;
    }
  }

  function cartItemNeedsDetails(item) {
    var properties = item && item.properties ? item.properties : {};
    var needsDetails = String(properties._details_required || "") === "true";
    if (!needsDetails) return false;
    return !Object.keys(properties).some(function (key) {
      return key.charAt(0) !== "_" && key !== "Gift for someone else" && properties[key] !== null && String(properties[key]).trim() !== "";
    });
  }

  function getCartFormVariantId(form) {
    var variant = form && form.elements ? form.elements.namedItem("id") : null;
    return variant ? String(variant.value || "") : "";
  }

  function collectLineItemProperties(container) {
    var properties = {};
    if (!container) return properties;

    container.querySelectorAll("[name^='properties[']").forEach(function (field) {
      if (field.disabled || !field.name) return;
      if ((field.type === "radio" || field.type === "checkbox") && !field.checked) return;
      var match = field.name.match(/^properties\[(.+)\]$/);
      if (!match) return;
      var value = field.value == null ? "" : String(field.value);
      if (value.trim() === "") return;
      properties[match[1]] = value;
    });

    return properties;
  }

  function ensureCardCartState(form) {
    if (!form.matches(".product-card-quick-add, .reader-directory-form, .hero-showcase-reader-cart, .featured-report-quick-add")) return null;
    var state = form.querySelector("[data-card-cart-state]");
    if (state) return state;
    state = document.createElement("div");
    state.className = "card-cart-state";
    state.dataset.cardCartState = "";
    state.hidden = true;
    state.innerHTML = '<span class="card-cart-state-label"><svg aria-hidden="true" fill="none" viewBox="0 0 18 18"><path d="m4 9 3 3 7-7" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"></path></svg>In cart</span><div class="card-cart-quantity"><button aria-label="Remove one from cart" data-card-cart-decrease type="button">−</button><strong aria-live="polite" data-card-cart-quantity>0</strong><button aria-label="Add one more to cart" data-card-cart-increase type="button">+</button></div>';
    var stateHost = form.matches(".featured-report-quick-add")
      ? form.querySelector(".quick-add-controls") || form
      : form;
    stateHost.appendChild(state);
    return state;
  }

  function setCartFormError(form, message) {
    var error = form.querySelector("[data-ajax-cart-error]");
    if (!error) {
      error = document.createElement("p");
      error.className = "ajax-cart-error";
      error.dataset.ajaxCartError = "";
      error.setAttribute("aria-live", "polite");
      form.appendChild(error);
    }
    error.textContent = message || "";
    error.hidden = !message;
  }

  function syncCardCartForms(cart) {
    document.querySelectorAll("form.product-card-quick-add, form.reader-directory-form, form.hero-showcase-reader-cart, form.featured-report-quick-add").forEach(function (form) {
      var variantId = getCartFormVariantId(form);
      var quantity = (cart.items || []).reduce(function (total, item) {
        return String(item.variant_id) === variantId ? total + item.quantity : total;
      }, 0);
      var state = ensureCardCartState(form);
      var submit = form.querySelector('[type="submit"]');
      var addControl = form.matches(".featured-report-quick-add")
        ? submit
        : form.querySelector(".quick-add-controls") || submit;
      if (state) {
        state.hidden = quantity < 1;
        var quantityLabel = state.querySelector("[data-card-cart-quantity]");
        if (quantityLabel) quantityLabel.textContent = String(quantity);
      }
      if (addControl) addControl.hidden = quantity > 0;
    });
  }

  function renderCartPopover(cart) {
    var popover = document.querySelector("[data-cart-popover]");
    if (!popover) return;
    var countLabel = popover.querySelector("[data-cart-popover-count]");
    var heading = countLabel && countLabel.parentElement;
    var content = popover.querySelector("[data-cart-popover-content]");
    var footer = popover.querySelector("[data-cart-popover-footer]");
    var subtotal = popover.querySelector("[data-cart-popover-subtotal]");
    var checkout = popover.querySelector("[data-cart-popover-checkout]");
    var detailsNote = popover.querySelector("[data-cart-popover-details-note]");
    var hasMissingDetails = (cart.items || []).some(cartItemNeedsDetails);

    if (countLabel) countLabel.textContent = String(cart.item_count || 0);
    if (heading) heading.lastChild.textContent = cart.item_count === 1 ? " item" : " items";
    if (subtotal) subtotal.textContent = formatCartMoney(cart.total_price);
    if (footer) footer.hidden = !cart.item_count;
    if (detailsNote) detailsNote.hidden = !hasMissingDetails;
    if (checkout) checkout.href = cartRootPath() + (hasMissingDetails ? "cart" : "checkout");

    if (!content) return;
    if (!cart.item_count) {
      content.innerHTML = '<div class="cart-popover-empty"><strong>Your cart is empty</strong><p>Add a reading or report and it will appear here.</p></div>';
      return;
    }

    content.innerHTML = '<div class="cart-popover-items">' + cart.items.map(function (item) {
      var itemImage = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      var itemHandle = item.handle || String(item.url || "").split("/products/")[1] || "";
      itemHandle = itemHandle.split(/[?#]/)[0];
      var readerFallbacks = {
        "patrick-consultation": popover.dataset.readerFallbackPatrick,
        "rhys-consultation": popover.dataset.readerFallbackRhys,
        "miriam-consultation": popover.dataset.readerFallbackMiriam,
        "robin-consultation": popover.dataset.readerFallbackRobin,
        "alyssa-consultation": popover.dataset.readerFallbackAlyssa
      };
      if (readerFallbacks[itemHandle]) itemImage = readerFallbacks[itemHandle];
      var imageMarkup = itemImage
        ? '<img alt="" loading="lazy" src="' + escapeHtml(itemImage) + '">'
        : '<span aria-hidden="true">PA</span>';
      var variantMarkup = item.variant_title && item.variant_title !== "Default Title"
        ? '<small>' + escapeHtml(item.variant_title) + '</small>'
        : "";
      var giftMarkup = item.properties && item.properties["Gift for someone else"] === "Yes"
        ? '<span class="cart-popover-gift">Gift</span>'
        : "";
      return '<article class="cart-popover-item"><a href="' + escapeHtml(item.url || cartRootPath() + "cart") + '" tabindex="-1">' + imageMarkup + '</a><div><a href="' + escapeHtml(item.url || cartRootPath() + "cart") + '">' + escapeHtml(item.product_title || item.title) + '</a>' + variantMarkup + giftMarkup + '<div class="cart-popover-item-footer"><div class="cart-popover-quantity" aria-label="Quantity for ' + escapeHtml(item.product_title || item.title) + '"><button aria-label="Decrease quantity" data-cart-popover-change="-1" data-cart-item-key="' + escapeHtml(item.key) + '" type="button">−</button><strong>' + item.quantity + '</strong><button aria-label="Increase quantity" data-cart-popover-change="1" data-cart-item-key="' + escapeHtml(item.key) + '" type="button">+</button></div><strong>' + escapeHtml(formatCartMoney(item.final_line_price)) + '</strong></div></div></article>';
    }).join("") + '</div>';
  }

  function updateCartState(cart) {
    ajaxCart.cart = cart;
    document.querySelectorAll("[data-cart-count]").forEach(function (count) {
      count.textContent = String(cart.item_count || 0);
      count.hidden = !cart.item_count;
    });
    renderCartPopover(cart);
    syncCardCartForms(cart);
  }

  function fetchCartState(forceRefresh) {
    if (ajaxCart.request) {
      if (forceRefresh) {
        return ajaxCart.request.catch(function () {}).then(function () { return fetchCartState(true); });
      }
      return ajaxCart.request;
    }
    ajaxCart.request = fetch(cartRootPath() + "cart.js", {
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to load the cart.");
        return response.json();
      })
      .then(function (cart) {
        updateCartState(cart);
        return cart;
      })
      .finally(function () {
        ajaxCart.request = null;
      });
    return ajaxCart.request;
  }

  function openCartPopover(moveFocus) {
    var popover = document.querySelector("[data-cart-popover]");
    var trigger = document.querySelector("[data-cart-trigger]");
    if (!popover || !trigger) return;
    popover.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("has-cart-popover-open");
    if (moveFocus) {
      var close = popover.querySelector("[data-cart-popover-close]");
      if (close) close.focus();
    }
  }

  function closeCartPopover(returnFocus) {
    var popover = document.querySelector("[data-cart-popover]");
    var trigger = document.querySelector("[data-cart-trigger]");
    if (!popover || popover.hidden) return;
    popover.hidden = true;
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("has-cart-popover-open");
    if (returnFocus && trigger) trigger.focus();
  }

  function setCartFormBusy(form, busy) {
    form.setAttribute("aria-busy", busy ? "true" : "false");
    form.querySelectorAll("button").forEach(function (button) {
      button.disabled = busy || button.dataset.cartOriginallyDisabled === "true";
    });
  }

  function addCartForm(form, submitButton) {
    setCartFormError(form, "");
    setCartFormBusy(form, true);
    var variantId = getCartFormVariantId(form);
    var quantityField = form.elements && form.elements.namedItem("quantity");
    var quantity = Math.max(1, Number(quantityField && quantityField.value) || 1);
    var item = {
      id: variantId,
      quantity: quantity,
      properties: collectLineItemProperties(form)
    };
    var sellingPlan = form.elements && form.elements.namedItem("selling_plan");
    if (sellingPlan && sellingPlan.value) item.selling_plan = sellingPlan.value;

    var itemAdded = false;
    return fetch(cartRootPath() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw new Error(payload.description || "This item could not be added.");
          itemAdded = true;
          return payload;
        });
      })
      .then(function () {
        return fetchCartState(true);
      })
      .then(function () {
        openCartPopover(false);
        if (submitButton && !form.matches(".product-card-quick-add, .reader-directory-form, .hero-showcase-reader-cart, .featured-report-quick-add")) {
          var label = submitButton.querySelector("span:last-child") || submitButton;
          var original = label.textContent;
          label.textContent = "Added to cart";
          window.setTimeout(function () { label.textContent = original; }, 1800);
        }
      })
      .catch(function (error) {
        if (itemAdded) {
          // The add succeeded but the follow-up cart refresh failed. Going to
          // Shopify's cart avoids inviting a duplicate retry with a misleading
          // "Failed to fetch" message.
          window.location.assign(cartRootPath() + "cart");
          return;
        }
        var message = error && error.message && error.message !== "Failed to fetch"
          ? error.message
          : "We could not reach the cart. Please check your connection and try again.";
        setCartFormError(form, message);
      })
      .finally(function () {
        setCartFormBusy(form, false);
      });
  }

  function changeCartItem(key, quantity, control) {
    if (control) control.disabled = true;
    return fetch(cartRootPath() + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to update the cart.");
        return response.json();
      })
      .then(updateCartState)
      .catch(function () {
        return fetchCartState();
      })
      .finally(function () {
        if (control) control.disabled = false;
      });
  }

  function initCartGiftOptions(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-cart-gift-checkbox]").forEach(function (checkbox) {
      if (checkbox.dataset.paCartGiftReady === "true") return;
      checkbox.dataset.paCartGiftReady = "true";
      checkbox.addEventListener("change", function () {
        var line = Number(checkbox.dataset.cartLine || 0);
        var itemKey = checkbox.dataset.cartItemKey || "";
        var previousChecked = !checkbox.checked;
        var status = checkbox.closest("[data-cart-gift-option]").querySelector("[data-cart-gift-status]");
        checkbox.disabled = true;
        if (status) status.textContent = "Saving…";

        fetchCartState(true)
          .then(function (cart) {
            var item = itemKey
              ? cart.items.find(function (candidate) { return candidate.key === itemKey; })
              : cart.items[line - 1];
            if (!item) throw new Error("This cart item could not be found.");
            var properties = Object.assign({}, item.properties || {});
            if (checkbox.checked) {
              properties["Gift for someone else"] = "Yes";
            } else {
              delete properties["Gift for someone else"];
            }
            return fetch(cartRootPath() + "cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error("The gift choice could not be saved.");
            return response.json();
          })
          .then(function (cart) {
            updateCartState(cart);
            if (status) status.textContent = "Saved";
            window.setTimeout(function () {
              if (status) status.textContent = "";
            }, 1600);
          })
          .catch(function () {
            checkbox.checked = previousChecked;
            if (status) status.textContent = "Please try again";
          })
          .finally(function () {
            checkbox.disabled = false;
          });
      });
    });
  }

  function initCartLoveOffers(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-cart-love-offer]").forEach(function (offer) {
      if (offer.dataset.paCartLoveOfferReady === "true") return;
      offer.dataset.paCartLoveOfferReady = "true";
      var button = offer.querySelector("[data-cart-love-offer-switch]");
      var status = offer.querySelector("[data-cart-love-offer-status]");
      if (!button) return;

      function setStatus(message, isError) {
        if (!status) return;
        status.textContent = message;
        status.classList.toggle("is-error", Boolean(isError));
      }

      button.addEventListener("click", function () {
        var offerVariantId = offer.dataset.offerVariantId;
        var synastryKey = offer.dataset.synastryItemKey;
        var compositeKey = offer.dataset.compositeItemKey;
        if (!offerVariantId || !synastryKey || !compositeKey) {
          setStatus("The offer could not be prepared. Please refresh the page and try again.", true);
          return;
        }

        button.disabled = true;
        button.textContent = "Switching…";
        setStatus("Replacing the separate reports…", false);
        var addedOfferKey = "";

        fetchCartState(true)
          .then(function (cart) {
            var synastryItem = cart.items.find(function (item) { return item.key === synastryKey; });
            var compositeItem = cart.items.find(function (item) { return item.key === compositeKey; });
            if (!synastryItem || !compositeItem) throw new Error("The reports in your cart have changed. Please refresh the page.");

            var properties = {
              _details_required: "true",
              "Reports included": "Synastry Report and Composite Report",
              "Synastry chart system": offer.dataset.synastryChartSystem || synastryItem.variant_title || "Standard",
              "Composite chart system": offer.dataset.compositeChartSystem || compositeItem.variant_title || "Standard"
            };
            var ignoredProperties = ["Reports included", "Synastry chart system", "Composite chart system"];
            Object.keys(synastryItem.properties || {}).forEach(function (key) {
              if (ignoredProperties.indexOf(key) === -1) properties[key] = synastryItem.properties[key];
            });
            Object.keys(compositeItem.properties || {}).forEach(function (key) {
              if (ignoredProperties.indexOf(key) === -1 && typeof properties[key] === "undefined") {
                properties[key] = compositeItem.properties[key];
              }
            });

            return fetch(cartRootPath() + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({
                items: [{ id: String(offerVariantId), quantity: 1, properties: properties }]
              })
            }).then(function (response) {
              return response.json().then(function (payload) {
                if (!response.ok) throw new Error(payload.description || "The offer could not be added.");
                var addedItem = payload.items && payload.items[0] ? payload.items[0] : payload;
                addedOfferKey = addedItem.key || "";
                return {
                  synastryQuantity: synastryItem.quantity,
                  compositeQuantity: compositeItem.quantity
                };
              });
            });
          })
          .then(function (sourceQuantities) {
            var updates = {};
            updates[synastryKey] = Math.max(0, sourceQuantities.synastryQuantity - 1);
            updates[compositeKey] = Math.max(0, sourceQuantities.compositeQuantity - 1);
            return fetch(cartRootPath() + "cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ updates: updates })
            }).then(function (response) {
              if (!response.ok) throw new Error("The separate reports could not be removed.");
              return response.json();
            });
          })
          .then(function () {
            setStatus("Offer applied. Refreshing your cart…", false);
            window.location.reload();
          })
          .catch(function (error) {
            var rollback = addedOfferKey
              ? fetch(cartRootPath() + "cart/change.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json", Accept: "application/json" },
                  body: JSON.stringify({ id: addedOfferKey, quantity: 0 })
                }).catch(function () {})
              : Promise.resolve();
            rollback.finally(function () {
              button.disabled = false;
              button.textContent = "Switch to the offer";
              setStatus(error && error.message ? error.message : "The offer could not be applied. Please try again.", true);
            });
          });
      });
    });
  }

  function initGiftRecipientForms(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-gift-recipient-form]").forEach(function (form) {
      if (form.dataset.paGiftRecipientReady === "true") return;
      form.dataset.paGiftRecipientReady = "true";
      var choices = form.querySelectorAll("input[type='radio']");
      var fields = form.querySelector("[data-gift-recipient-fields]");
      var recipientEmail = form.querySelector("[data-gift-recipient-email]");
      var offset = form.querySelector("[data-gift-recipient-offset]");

      function syncGiftRecipientFields() {
        var selected = form.querySelector("input[type='radio']:checked");
        var sendToRecipient = selected && selected.value === "recipient";
        if (fields) fields.hidden = !sendToRecipient;
        form.querySelectorAll("[data-gift-recipient-input]").forEach(function (field) {
          field.disabled = !sendToRecipient;
        });
        if (recipientEmail) recipientEmail.required = Boolean(sendToRecipient);
        if (offset && sendToRecipient) offset.value = String(new Date().getTimezoneOffset());
      }

      choices.forEach(function (choice) {
        choice.addEventListener("change", syncGiftRecipientFields);
      });
      syncGiftRecipientFields();
    });
  }

  function initCartRecipientModes(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-cart-line-details-form]").forEach(function (detailsForm) {
      var choice = detailsForm.querySelector("[data-cart-recipient-choice]");
      if (!choice || choice.dataset.paRecipientChoiceReady === "true") return;
      choice.dataset.paRecipientChoiceReady = "true";
      var shared = detailsForm.querySelector("[data-cart-recipient-shared]");
      var separate = detailsForm.querySelector("[data-cart-recipient-separate]");

      function setFieldsEnabled(container, enabled) {
        if (!container) return;
        container.hidden = !enabled;
        container.querySelectorAll("input, select, textarea").forEach(function (field) {
          field.disabled = !enabled;
        });
      }

      function syncRecipientMode() {
        var selected = choice.querySelector("input[type='radio']:checked");
        var useSeparateDetails = selected && selected.value === "separate";
        setFieldsEnabled(shared, !useSeparateDetails);
        setFieldsEnabled(separate, useSeparateDetails);
      }

      choice.querySelectorAll("input[type='radio']").forEach(function (radio) {
        radio.addEventListener("change", syncRecipientMode);
      });
      syncRecipientMode();
    });
  }

  function initFocusSuggestionChips(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-focus-suggestions]").forEach(function (selector) {
      if (selector.dataset.paFocusSuggestionsReady === "true") return;
      selector.dataset.paFocusSuggestionsReady = "true";
      var output = selector.querySelector("[data-focus-suggestion-output]");

      function syncSelection() {
        if (!output) return;
        output.value = Array.from(selector.querySelectorAll("[data-focus-suggestion][aria-pressed='true']"))
          .map(function (chip) { return chip.value; })
          .join(", ");
      }

      selector.addEventListener("click", function (event) {
        var chip = event.target.closest("[data-focus-suggestion]");
        if (!chip || !selector.contains(chip)) return;
        var selected = chip.getAttribute("aria-pressed") === "true";
        chip.setAttribute("aria-pressed", selected ? "false" : "true");
        syncSelection();
      });

      syncSelection();
    });
  }

  function initTimePickers(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-time-picker]").forEach(function (picker) {
      if (picker.dataset.paTimePickerReady === "true") return;
      picker.dataset.paTimePickerReady = "true";

      var hourButtons = Array.from(picker.querySelectorAll("[data-time-hour]"));
      var minuteButtons = Array.from(picker.querySelectorAll("[data-time-minute]"));
      var output = picker.querySelector("[data-time-output]");
      var toggle = picker.querySelector("[data-time-picker-toggle]");
      var display = picker.querySelector("[data-time-display]");
      var popover = picker.querySelector("[data-time-picker-popover]");
      var done = picker.querySelector("[data-time-picker-done]");
      var clear = picker.querySelector("[data-time-picker-clear]");
      var periodButtons = Array.from(picker.querySelectorAll("[data-time-period]"));
      if (!hourButtons.length || !minuteButtons.length || !output || !toggle || !display || !popover || !done || !clear || !periodButtons.length) return;

      function selectedValue(buttons, fallback) {
        var selected = buttons.find(function (button) {
          return button.getAttribute("aria-selected") === "true";
        });
        return selected ? selected.value : fallback;
      }

      function selectButton(buttons, selectedButton) {
        buttons.forEach(function (button) {
          button.setAttribute("aria-selected", button === selectedButton ? "true" : "false");
        });
      }

      function centreSelectedOptions() {
        picker.querySelectorAll("[data-time-wheel]").forEach(function (wheel) {
          var selected = wheel.querySelector("[aria-selected='true']");
          if (!selected) return;
          var wheelRect = wheel.getBoundingClientRect();
          var selectedRect = selected.getBoundingClientRect();
          wheel.scrollTop += selectedRect.top - wheelRect.top - (wheel.clientHeight - selectedRect.height) / 2;
        });
      }

      function closePicker(restoreFocus) {
        popover.hidden = true;
        toggle.setAttribute("aria-expanded", "false");
        if (restoreFocus) toggle.focus();
      }

      function openPicker() {
        popover.hidden = false;
        toggle.setAttribute("aria-expanded", "true");
        window.requestAnimationFrame(function () {
          centreSelectedOptions();
        });
      }

      function updateDisplay() {
        display.textContent = output.value || "Choose a time";
        toggle.classList.toggle("has-value", Boolean(output.value));
        output.dispatchEvent(new Event("change", { bubbles: true }));
      }

      toggle.addEventListener("click", function () {
        if (popover.hidden) openPicker();
        else closePicker(false);
      });
      hourButtons.forEach(function (button) {
        button.addEventListener("click", function () { selectButton(hourButtons, button); });
      });
      minuteButtons.forEach(function (button) {
        button.addEventListener("click", function () { selectButton(minuteButtons, button); });
      });
      periodButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          selectButton(periodButtons, button);
        });
      });
      done.addEventListener("click", function () {
        output.value = selectedValue(hourButtons, "12") + ":" + selectedValue(minuteButtons, "00") + " " + selectedValue(periodButtons, "AM");
        updateDisplay();
        closePicker(true);
      });
      clear.addEventListener("click", function () {
        output.value = "";
        updateDisplay();
        closePicker(true);
      });
      picker.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !popover.hidden) {
          event.preventDefault();
          closePicker(true);
        }
      });
      document.addEventListener("click", function (event) {
        if (!popover.hidden && !picker.contains(event.target)) closePicker(false);
      });

      updateDisplay();
    });
  }

  function initReportRecipientForms(scope) {
    var root = scope || document;
    root.querySelectorAll("form.multi-recipient-report-form").forEach(function (form) {
      if (form.dataset.paReportRecipientsReady === "true") return;
      var manager = form.querySelector("[data-report-recipient-manager]");
      if (!manager) return;
      form.dataset.paReportRecipientsReady = "true";

      var list = manager.querySelector("[data-report-recipient-list]");
      var template = manager.querySelector("[data-report-recipient-template]");
      var addButton = manager.querySelector("[data-report-recipient-add]");
      var quantityInput = form.querySelector("[data-report-quantity]");
      var countTarget = manager.querySelector("[data-report-recipient-count]");
      var totalTarget = manager.querySelector("[data-report-recipient-total]");
      var limitMessage = manager.querySelector("[data-report-recipient-limit]");
      var maximumRecipients = 4;

      function recipientCards() {
        return Array.from(list ? list.querySelectorAll("[data-report-recipient]") : []);
      }

      function syncRecipients() {
        var cards = recipientCards();
        var count = cards.length;
        var heading = manager.dataset.recipientHeading || "Person";
        var unitLabel = manager.dataset.unitLabel || "report";
        var usePrefixes = count > 1;

        cards.forEach(function (card, index) {
          var number = index + 1;
          var numberTarget = card.querySelector("[data-report-recipient-number]");
          var titleTarget = card.querySelector("[data-report-recipient-title]");
          var removeButton = card.querySelector("[data-report-recipient-remove]");
          if (numberTarget) numberTarget.textContent = String(number);
          if (titleTarget) titleTarget.textContent = heading + " " + number;
          if (removeButton) removeButton.hidden = count === 1;
          card.querySelectorAll("[data-report-recipient-field]").forEach(function (field) {
            var base = field.dataset.propertyBase || "Report details";
            var propertyName = usePrefixes ? heading + " " + number + " - " + base : base;
            field.name = "properties[" + propertyName + "]";
          });
        });

        if (quantityInput) quantityInput.value = String(count);
        if (countTarget) countTarget.textContent = count + " " + unitLabel + (count === 1 ? "" : "s");
        if (totalTarget) totalTarget.textContent = formatCartMoney((Number(manager.dataset.unitPrice) || 0) * count);
        if (addButton) addButton.hidden = count >= maximumRecipients;
        if (limitMessage) limitMessage.hidden = count < maximumRecipients;
      }

      if (addButton && template && list) {
        addButton.addEventListener("click", function () {
          var cards = recipientCards();
          if (cards.length >= maximumRecipients) return;
          var nextNumber = cards.length + 1;
          var prefix = (manager.dataset.recipientHeading || "Person") + " " + nextNumber;
          var markup = template.innerHTML
            .replace(/__INDEX__/g, String(nextNumber))
            .replace(/__PREFIX__/g, prefix);
          var holder = document.createElement("div");
          holder.innerHTML = markup.trim();
          var card = holder.firstElementChild;
          if (!card) return;
          list.appendChild(card);
          syncRecipients();
          initFocusSuggestionChips(card);
          initTimePickers(card);
          var firstField = card.querySelector("input, select, textarea");
          if (firstField) firstField.focus();
        });
      }

      if (list) {
        list.addEventListener("click", function (event) {
          var removeButton = event.target.closest("[data-report-recipient-remove]");
          if (!removeButton || recipientCards().length === 1) return;
          var card = removeButton.closest("[data-report-recipient]");
          if (card) card.remove();
          syncRecipients();
        });
      }

      form.addEventListener("change", function (event) {
        if (event.target.name !== "id") return;
        var selected = event.target.options && event.target.options[event.target.selectedIndex];
        if (selected && selected.dataset.price) manager.dataset.unitPrice = selected.dataset.price;
        syncRecipients();
      });

      syncRecipients();
    });
  }

  function addMultiRecipientCartForm(form, submitButton) {
    var manager = form.querySelector("[data-report-recipient-manager]");
    var cards = manager ? Array.from(manager.querySelectorAll("[data-report-recipient-list] [data-report-recipient]")) : [];
    if (cards.length < 2) return addCartForm(form, submitButton);

    setCartFormError(form, "");
    setCartFormBusy(form, true);
    var variantId = getCartFormVariantId(form);
    var sharedProperties = collectLineItemProperties(form);
    cards.forEach(function (card) {
      card.querySelectorAll("[name^='properties[']").forEach(function (field) {
        var match = field.name.match(/^properties\[(.+)\]$/);
        if (match) delete sharedProperties[match[1]];
      });
    });

    var items = cards.map(function (card, index) {
      var properties = Object.assign({}, sharedProperties);
      card.querySelectorAll("[data-report-recipient-field]").forEach(function (field) {
        if ((field.type === "radio" || field.type === "checkbox") && !field.checked) return;
        var value = String(field.value || "").trim();
        if (!value) return;
        properties[field.dataset.propertyBase || "Report details"] = field.value;
      });
      properties._details_mode = "separate";
      properties._details_people_count = "1";
      properties._recipient_number = String(index + 1);
      return { id: variantId, quantity: 1, properties: properties };
    });

    return fetch(cartRootPath() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw new Error(payload.description || "These reports could not be added.");
          return payload;
        });
      })
      .then(function () { return fetchCartState(true); })
      .then(function () {
        openCartPopover(false);
        var label = submitButton && (submitButton.querySelector("span:last-child") || submitButton);
        if (!label) return;
        var original = label.textContent;
        label.textContent = "All reports added to cart";
        window.setTimeout(function () { label.textContent = original; }, 2200);
      })
      .catch(function (error) {
        setCartFormError(form, error.message || "These reports could not be added. Please try again.");
      })
      .finally(function () { setCartFormBusy(form, false); });
  }

  function initLoveReportBundles(scope) {
    var root = scope || document;
    var bundles = [];
    if (root.matches && root.matches("[data-love-report-bundle]")) bundles.push(root);
    root.querySelectorAll("[data-love-report-bundle]").forEach(function (bundle) { bundles.push(bundle); });

    bundles.forEach(function (bundle) {
      if (bundle.dataset.paLoveReportBundleReady === "true") return;
      bundle.dataset.paLoveReportBundleReady = "true";
      var button = bundle.querySelector("[data-love-report-add-both]");
      var status = bundle.querySelector("[data-love-report-bundle-status]");
      if (!button) return;

      button.addEventListener("click", function () {
        var offerChartSystem = bundle.querySelector("[data-love-report-offer-chart]");
        var offerVariantId = bundle.dataset.loveReportOfferVariant;
        if (!offerChartSystem || !offerChartSystem.value || !offerVariantId) {
          if (status) {
            status.textContent = "Please choose a chart system. The offer is not available yet.";
            status.classList.add("is-error");
          }
          return;
        }

        if (status) {
          status.textContent = "";
          status.classList.remove("is-error");
        }
        setCartFormBusy(bundle, true);
        var selectedChartSystem = offerChartSystem.value;
        var items = [{
          id: String(offerVariantId),
          quantity: 1,
          properties: {
            _details_required: "true",
            "Reports included": "Synastry Report and Composite Report",
            "Synastry chart system": selectedChartSystem,
            "Composite chart system": selectedChartSystem
          }
        }];

        fetch(cartRootPath() + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok) throw new Error(payload.description || "The reports could not be added.");
              return payload;
            });
          })
          .then(function () { return fetchCartState(true); })
          .then(function () {
            openCartPopover(false);
            if (status) status.textContent = "Your two-report offer has been added to your cart.";
            var label = button.querySelector("span:last-child") || button;
            var original = label.textContent;
            label.textContent = "Offer added to cart";
            window.setTimeout(function () { label.textContent = original; }, 2200);
          })
          .catch(function (error) {
            if (status) {
              status.textContent = error.message || "The reports could not be added. Please try again.";
              status.classList.add("is-error");
            }
          })
          .finally(function () { setCartFormBusy(bundle, false); });
      });
    });
  }

  function initLoveReportHeroCards(scope) {
    var root = scope || document;
    var showcases = [];
    if (root.matches && root.matches("[data-love-report-hero-cards]")) showcases.push(root);
    root.querySelectorAll("[data-love-report-hero-cards]").forEach(function (showcase) { showcases.push(showcase); });

    showcases.forEach(function (showcase) {
      if (showcase.dataset.paLoveReportHeroReady === "true") return;
      showcase.dataset.paLoveReportHeroReady = "true";

      var cards = Array.from(showcase.querySelectorAll("[data-love-report-hero-card]"));
      var controls = Array.from(showcase.querySelectorAll("[data-love-report-hero-control]"));
      var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var activeIndex = Math.max(0, cards.findIndex(function (card) { return card.classList.contains("is-active"); }));
      var timer = null;

      if (cards.length < 2) return;

      function showCard(index) {
        activeIndex = (index + cards.length) % cards.length;
        cards.forEach(function (card, cardIndex) {
          var active = cardIndex === activeIndex;
          card.classList.toggle("is-active", active);
          card.setAttribute("aria-current", active ? "true" : "false");
        });
        controls.forEach(function (control, controlIndex) {
          var active = controlIndex === activeIndex;
          control.classList.toggle("is-active", active);
          control.setAttribute("aria-pressed", active ? "true" : "false");
        });
      }

      function stopAutoplay() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }

      function startAutoplay() {
        stopAutoplay();
        if (reducedMotion || document.hidden) return;
        timer = window.setInterval(function () { showCard(activeIndex + 1); }, 4200);
      }

      cards.forEach(function (card, index) {
        card.addEventListener("pointerenter", function () { showCard(index); });
        card.addEventListener("focus", function () { showCard(index); });
        card.addEventListener("click", function () { showCard(index); });
      });

      controls.forEach(function (control, index) {
        control.addEventListener("click", function () { showCard(index); });
      });

      showcase.addEventListener("pointerenter", stopAutoplay);
      showcase.addEventListener("pointerleave", startAutoplay);
      showcase.addEventListener("focusin", stopAutoplay);
      showcase.addEventListener("focusout", function (event) {
        if (!showcase.contains(event.relatedTarget)) startAutoplay();
      });
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      showCard(activeIndex);
      startAutoplay();
    });
  }

  function initAjaxCart(scope) {
    var root = scope || document;
    var forms = [];
    if (root.matches && root.matches('form[action*="/cart/add"]')) forms.push(root);
    root.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) { forms.push(form); });

    forms.forEach(function (form) {
      if (form.dataset.paAjaxCartReady === "true") return;
      form.dataset.paAjaxCartReady = "true";
      form.querySelectorAll("button").forEach(function (button) {
        button.dataset.cartOriginallyDisabled = button.disabled ? "true" : "false";
      });
      var state = ensureCardCartState(form);
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var submitButton = event.submitter || form.querySelector('[type="submit"]');
        if (form.matches(".multi-recipient-report-form")) addMultiRecipientCartForm(form, submitButton);
        else addCartForm(form, submitButton);
      });
      form.addEventListener("change", function (event) {
        if (event.target.name === "id" && ajaxCart.cart) syncCardCartForms(ajaxCart.cart);
      });
      if (state) {
        state.addEventListener("click", function (event) {
          var increase = event.target.closest("[data-card-cart-increase]");
          var decrease = event.target.closest("[data-card-cart-decrease]");
          if (increase) {
            addCartForm(form, increase);
            return;
          }
          if (!decrease || !ajaxCart.cart) return;
          var variantId = getCartFormVariantId(form);
          var item = ajaxCart.cart.items.find(function (candidate) {
            return String(candidate.variant_id) === variantId;
          });
          if (item) changeCartItem(item.key, item.quantity - 1, decrease);
        });
      }
    });

    var shell = root.querySelector && root.querySelector("[data-cart-shell]");
    if (!shell && root.matches && root.matches("[data-cart-shell]")) shell = root;
    if (shell && shell.dataset.paAjaxCartReady !== "true") {
      shell.dataset.paAjaxCartReady = "true";
      var trigger = shell.querySelector("[data-cart-trigger]");
      var popover = shell.querySelector("[data-cart-popover]");
      if (trigger) {
        trigger.addEventListener("click", function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (popover && !popover.hidden) {
            closeCartPopover(false);
          } else {
            openCartPopover(false);
            fetchCartState();
          }
        });
      }
      shell.querySelectorAll("[data-cart-popover-close]").forEach(function (button) {
        button.addEventListener("click", function () { closeCartPopover(true); });
      });
      if (popover) {
        popover.addEventListener("click", function (event) {
          var button = event.target.closest("[data-cart-popover-change]");
          if (!button || !ajaxCart.cart) return;
          var key = button.dataset.cartItemKey;
          var item = ajaxCart.cart.items.find(function (candidate) { return candidate.key === key; });
          if (!item) return;
          changeCartItem(key, item.quantity + Number(button.dataset.cartPopoverChange || 0), button);
        });
      }
    }

    if (document.documentElement.dataset.paAjaxCartGlobalReady !== "true") {
      document.documentElement.dataset.paAjaxCartGlobalReady = "true";
      document.addEventListener("click", function (event) {
        var popover = document.querySelector("[data-cart-popover]");
        if (!popover || popover.hidden || event.target.closest("[data-cart-shell]")) return;
        closeCartPopover(false);
      });
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") closeCartPopover(true);
      });
      fetchCartState().catch(function () {});
    } else if (ajaxCart.cart) {
      updateCartState(ajaxCart.cart);
    }
  }

  function initEnquiryHighlight(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-enquiry-jump]").forEach(function (button) {
      if (button.dataset.paEnquiryHighlightReady === "true") return;
      button.dataset.paEnquiryHighlightReady = "true";
      button.addEventListener("click", function (event) {
        var card = document.querySelector("[data-enquiry-form-card]");
        if (!card) return;
        event.preventDefault();
        var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        card.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, "", "#booking-enquiry");
        }
        window.setTimeout(function () {
          card.classList.remove("is-highlighted");
          void card.offsetWidth;
          card.classList.add("is-highlighted");
          window.setTimeout(function () {
            card.classList.remove("is-highlighted");
          }, 2200);
        }, reducedMotion ? 0 : 320);
      });
    });
  }

  function initReaderServiceChoices(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-reader-service-options]").forEach(function (section) {
      if (section.dataset.paReaderServiceChoicesReady === "true") return;
      section.dataset.paReaderServiceChoicesReady = "true";

      var form = document.getElementById("ConsultationBooking");
      if (!form) return;
      var variantControl = form.querySelector("[data-reader-service-selector]") || form.elements.namedItem("id");
      var consultationRequest = form.querySelector("[data-consultation-request]");
      var cards = Array.from(section.querySelectorAll("[data-reader-service-option]"));
      var choices = Array.from(section.querySelectorAll("[data-reader-service-choice]"));
      var robinDeliveryInput = form.querySelector("[data-robin-delivery-format]");
      var robinDeliveryLabel = form.querySelector("[data-robin-delivery-label]");
      var robinLiveFields = Array.from(form.querySelectorAll("[data-robin-live-field]"));
      var productNameInput = form.querySelector("[data-reader-product-name]");
      var standardFormPanel = document.querySelector("[data-standard-consultation-form]");
      var emergencyFormPanel = document.querySelector("[data-emergency-enquiry-form]");
      var standardIntro = document.querySelector("[data-standard-consultation-intro]");
      var emergencyIntro = document.querySelector("[data-emergency-enquiry-intro]");
      var emergencyCard = section.querySelector("[data-emergency-service-option]");
      var emergencyChoices = Array.from(section.querySelectorAll("[data-emergency-enquiry-choice]"));
      var emergencySelector = emergencyFormPanel
        ? emergencyFormPanel.querySelector("[data-emergency-service-selector]")
        : null;
      var lastRegularVariantId = variantControl && String(variantControl.value || "") !== "emergency"
        ? String(variantControl.value || "")
        : "";

      function setEmergencyMode(isEmergency) {
        if (!standardFormPanel || !emergencyFormPanel) return;
        standardFormPanel.hidden = isEmergency;
        emergencyFormPanel.hidden = !isEmergency;
        if (standardIntro) standardIntro.hidden = isEmergency;
        if (emergencyIntro) emergencyIntro.hidden = !isEmergency;
        cards.forEach(function (card) {
          if (isEmergency) card.classList.remove("is-selected");
        });
        if (emergencyCard) emergencyCard.classList.toggle("is-selected", isEmergency);
        emergencyChoices.forEach(function (choice) {
          if (isEmergency) choice.setAttribute("aria-current", "true");
          else choice.removeAttribute("aria-current");
        });
        if (isEmergency) {
          if (variantControl && String(variantControl.value || "") !== "emergency") {
            lastRegularVariantId = String(variantControl.value || "");
            variantControl.value = "emergency";
          }
          if (emergencySelector) emergencySelector.value = "emergency";
        }
      }

      function selectedVariantId() {
        return variantControl ? String(variantControl.value || "") : "";
      }

      function syncSelection(variantId) {
        setEmergencyMode(false);
        if (variantId && variantId !== "emergency") lastRegularVariantId = variantId;
        cards.forEach(function (card) {
          card.classList.toggle("is-selected", card.dataset.variantId === variantId);
        });
        choices.forEach(function (choice) {
          if (choice.dataset.variantId === variantId) choice.setAttribute("aria-current", "true");
          else choice.removeAttribute("aria-current");
        });
        if (consultationRequest && variantControl && variantControl.options) {
          var enquiryOption = variantControl.options[variantControl.selectedIndex];
          consultationRequest.value = enquiryOption && enquiryOption.dataset.consultationLabel
            ? enquiryOption.dataset.consultationLabel
            : enquiryOption ? enquiryOption.textContent.trim() : "";
        }
        if (robinDeliveryInput && variantControl && variantControl.options) {
          var selectedOption = variantControl.options[variantControl.selectedIndex];
          var delivery = selectedOption && selectedOption.dataset.deliveryFormat
            ? selectedOption.dataset.deliveryFormat
            : selectedOption && /email/i.test(selectedOption.textContent || "") ? "Email reading" : "VOIP phone call";
          var isEmail = delivery === "Email reading";
          robinDeliveryInput.value = delivery;
          if (robinDeliveryLabel) robinDeliveryLabel.textContent = delivery;
          if (productNameInput && selectedOption && selectedOption.dataset.productTitle) {
            productNameInput.value = selectedOption.dataset.productTitle;
          }
          robinLiveFields.forEach(function (field) {
            field.hidden = isEmail;
            field.querySelectorAll("input, select, textarea").forEach(function (control) {
              if (isEmail) {
                control.dataset.wasRequired = control.required ? "true" : "false";
                control.required = false;
                control.disabled = true;
              } else {
                control.disabled = false;
                if (control.dataset.wasRequired === "true") control.required = true;
              }
            });
          });
        }
      }

      choices.forEach(function (choice) {
        choice.addEventListener("click", function (event) {
          if (choice.getAttribute("aria-disabled") === "true") {
            event.preventDefault();
            return;
          }
          var variantId = choice.dataset.variantId || "";
          if (variantControl && variantId) {
            variantControl.value = variantId;
            variantControl.dispatchEvent(new Event("change", { bubbles: true }));
          }
          syncSelection(variantId);
        });
      });

      emergencyChoices.forEach(function (choice) {
        choice.addEventListener("click", function () {
          setEmergencyMode(true);
        });
      });

      if (emergencySelector) {
        emergencySelector.addEventListener("change", function () {
          if (emergencySelector.value === "emergency") {
            setEmergencyMode(true);
            return;
          }
          if (!variantControl) return;
          variantControl.value = emergencySelector.value;
          variantControl.dispatchEvent(new Event("change", { bubbles: true }));
          window.requestAnimationFrame(function () {
            if (variantControl && typeof variantControl.focus === "function") variantControl.focus();
          });
        });
      }

      document.querySelectorAll("[data-standard-consultation-choice]").forEach(function (button) {
        if (button.dataset.paStandardConsultationChoiceReady === "true") return;
        button.dataset.paStandardConsultationChoiceReady = "true";
        button.addEventListener("click", function () {
          var regularVariantId = selectedVariantId() === "emergency" ? lastRegularVariantId : selectedVariantId();
          if (variantControl && regularVariantId) variantControl.value = regularVariantId;
          syncSelection(regularVariantId);
          var standardHeading = form.querySelector("input, select, textarea, button");
          if (standardHeading) standardHeading.focus();
        });
      });

      if (variantControl && variantControl.addEventListener) {
        variantControl.addEventListener("change", function () {
          if (selectedVariantId() === "emergency" && emergencyFormPanel) {
            setEmergencyMode(true);
            return;
          }
          syncSelection(selectedVariantId());
        });
      }
      syncSelection(selectedVariantId());
      if (emergencyFormPanel && emergencyFormPanel.querySelector("[data-emergency-enquiry-posted]")) {
        setEmergencyMode(true);
      }
    });
  }

  function initHoraryQuestionExamples(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-horary-question-example]").forEach(function (example) {
      if (example.dataset.paHoraryQuestionsReady === "true") return;
      example.dataset.paHoraryQuestionsReady = "true";

      var firstQuestion = example.querySelector("[data-horary-first-question]");
      var realQuestion = example.querySelector("[data-horary-real-question]");
      var examplesData = example.querySelector("[data-horary-question-examples]");
      if (!firstQuestion || !realQuestion || !examplesData) return;

      var questions;
      try {
        questions = JSON.parse(examplesData.textContent || "[]");
      } catch (error) {
        return;
      }
      if (!Array.isArray(questions) || questions.length < 2) return;

      var defaultFirst = firstQuestion.textContent;
      var defaultReal = realQuestion.textContent;
      var questionIndex = 0;
      var hasStarted = false;

      function reducedMotionEnabled() {
        var systemPreference = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        return systemPreference || document.documentElement.classList.contains("pa-a11y-reduce-motion");
      }

      function wait(duration) {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, duration);
        });
      }

      async function typeQuestion(element, text) {
        element.textContent = "";
        element.classList.add("is-typing");
        for (var index = 0; index < text.length; index += 1) {
          if (!document.documentElement.contains(example) || reducedMotionEnabled()) return false;
          element.textContent += text.charAt(index);
          await wait(index > 0 && /[,.?!]/.test(text.charAt(index - 1)) ? 115 : 42);
        }
        element.classList.remove("is-typing");
        return true;
      }

      async function runSequence() {
        while (document.documentElement.contains(example) && !reducedMotionEnabled()) {
          var pair = questions[questionIndex];
          firstQuestion.textContent = "";
          realQuestion.textContent = "";

          if (!await typeQuestion(firstQuestion, pair.first)) break;
          await wait(420);
          if (!await typeQuestion(realQuestion, pair.real)) break;
          await wait(3600);

          questionIndex = (questionIndex + 1) % questions.length;
        }

        firstQuestion.classList.remove("is-typing");
        realQuestion.classList.remove("is-typing");
        if (reducedMotionEnabled()) {
          firstQuestion.textContent = defaultFirst;
          realQuestion.textContent = defaultReal;
        }
      }

      function startSequence() {
        if (hasStarted || reducedMotionEnabled()) return;
        hasStarted = true;
        runSequence();
      }

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          observer.disconnect();
          startSequence();
        }, { rootMargin: "0px 0px -12%", threshold: 0.25 });
        observer.observe(example);
      } else {
        startSequence();
      }
    });
  }

  function initReaderOfferingJumps(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-reader-offering-jump]").forEach(function (button) {
      if (button.dataset.paReaderOfferingJumpReady === "true") return;
      button.dataset.paReaderOfferingJumpReady = "true";
      button.addEventListener("click", function (event) {
        var targetId = String(button.getAttribute("href") || "").replace(/^#/, "");
        var card = targetId ? document.getElementById(targetId) : null;
        if (!card) return;
        event.preventDefault();

        if (card.hidden) {
          var directory = card.closest("[data-reader-directory]");
          var allReaders = directory && directory.querySelector('[data-reader-filter="all"]');
          if (allReaders) allReaders.click();
          card.hidden = false;
        }

        var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        card.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, "", "#" + targetId);
        }
        window.setTimeout(function () {
          card.classList.remove("is-jump-highlighted");
          void card.offsetWidth;
          card.classList.add("is-jump-highlighted");
          window.setTimeout(function () {
            card.classList.remove("is-jump-highlighted");
          }, 2200);
        }, reducedMotion ? 0 : 320);
      });
    });
  }

  function initHeroCarousels(scope) {
    var root = scope || document;
    var carousels = [];

    if (root.matches && root.matches("[data-hero-carousel]")) {
      carousels.push(root);
    }

    root.querySelectorAll("[data-hero-carousel]").forEach(function (carousel) {
      carousels.push(carousel);
    });

    carousels.forEach(function (carousel) {
      if (carousel.dataset.paHeroCarouselReady === "true") return;
      carousel.dataset.paHeroCarouselReady = "true";

      var slides = Array.from(carousel.querySelectorAll("[data-hero-slide]"));
      var dots = Array.from(carousel.querySelectorAll("[data-hero-dot]"));
      var previous = carousel.querySelector("[data-hero-previous]");
      var next = carousel.querySelector("[data-hero-next]");
      var current = 0;

      if (slides.length < 2) return;

      function showSlide(nextIndex) {
        current = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, index) {
          var active = index === current;
          slide.hidden = !active;
          slide.classList.toggle("is-active", active);
          slide.setAttribute("aria-hidden", active ? "false" : "true");
        });
        dots.forEach(function (dot, index) {
          dot.setAttribute("aria-pressed", index === current ? "true" : "false");
        });
      }

      function chooseSlide(nextIndex) {
        showSlide(nextIndex);
      }

      if (previous) previous.addEventListener("click", function () { chooseSlide(current - 1); });
      if (next) next.addEventListener("click", function () { chooseSlide(current + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          chooseSlide(Number(dot.getAttribute("data-hero-dot")) || 0);
        });
      });

      carousel._paShowHeroSlide = showSlide;
      showSlide(0);
    });
  }

  function initMenu(scope) {
    var root = scope || document;
    var menus = [];

    if (root.matches && root.matches("[data-store-menu]")) {
      menus.push(root);
    }

    root.querySelectorAll("[data-store-menu]").forEach(function (menu) {
      menus.push(menu);
    });

    menus.forEach(function (menu) {
      if (menu.dataset.paMenuReady === "true") return;
      menu.dataset.paMenuReady = "true";

      var trigger = menu.querySelector("[data-menu-trigger]");
      var layer = menu.querySelector("[data-menu-layer]");
      var closeButtons = menu.querySelectorAll("[data-menu-close]");
      if (!trigger || !layer) return;

      function openMenu() {
        layer.classList.remove("is-closed");
        layer.classList.add("is-open");
        layer.setAttribute("aria-hidden", "false");
        trigger.setAttribute("aria-expanded", "true");
        document.documentElement.style.overflow = "hidden";
      }

      function closeMenu() {
        layer.classList.remove("is-open");
        layer.classList.add("is-closed");
        layer.setAttribute("aria-hidden", "true");
        trigger.setAttribute("aria-expanded", "false");
        document.documentElement.style.overflow = "";
      }

      menu._paOpenMenu = openMenu;
      menu._paCloseMenu = closeMenu;

      trigger.addEventListener("click", function () {
        if (layer.classList.contains("is-open")) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      closeButtons.forEach(function (button) {
        button.addEventListener("click", closeMenu);
      });

      menu.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", closeMenu);
      });

    });
  }

  function initMenuKeyboardClose() {
    if (document.documentElement.dataset.paMenuKeyboardReady === "true") return;
    document.documentElement.dataset.paMenuKeyboardReady = "true";
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      document.querySelectorAll("[data-store-menu]").forEach(function (menu) {
        if (menu._paCloseMenu) menu._paCloseMenu();
      });
    });
  }

  var finderQuestions = [
    {
      id: "support",
      prompt: "Which kind of guidance feels closest?",
      helper: "Choose the approach you are most drawn to right now.",
      options: [
        { id: "birth-chart", label: "Birth chart and personal timing", description: "Explore your chart, current cycles and the timing around a decision.", scores: { "patrick-reading": 4, "all-readers": 1 } },
        { id: "focused-question", label: "One clearly framed question", description: "A focused Horary astrology answer without needing a recorded birth time.", priority: 100, priorityResult: "rhys-reading", scores: { "rhys-reading": 4, "all-readers": 1 } },
        { id: "psychic", label: "Psychic or intuitive guidance", description: "Mediumship, reassurance and insight led by intuition.", scores: { "psychic-reading": 4, "alyssa-reading": 1 } },
        { id: "written", label: "A written astrology report", description: "Personal guidance to read, keep and return to in your own time.", scores: { "all-reports": 4, "special-offer": 1 } }
      ]
    },
    {
      id: "topic",
      prompt: "What is at the heart of your question?",
      helper: "This helps match the subject to the right reader or written route.",
      options: [
        { id: "timing", label: "Timing, decisions and my next phase", description: "Understand the cycles around a change, opportunity or life chapter.", scores: { "patrick-reading": 4, "special-offer": 1 } },
        { id: "specific", label: "One specific issue needing a clear answer", description: "Bring one sincere question to a focused traditional astrology reading.", priority: 100, priorityResult: "rhys-reading", scores: { "rhys-reading": 4, "patrick-reading": 1 } },
        { id: "connection", label: "Connection, reassurance or intuitive insight", description: "Explore mediumship, spiritual guidance or what you are sensing now.", scores: { "psychic-reading": 4, "all-readers": 1 } },
        { id: "growth", label: "Personal growth and practical next steps", description: "Work through emotions, choices and change in a supportive conversation.", scores: { "alyssa-reading": 4, "all-readers": 1 } }
      ]
    },
    {
      id: "format",
      prompt: "How would you like to receive the guidance?",
      helper: "Choose the experience that would feel most useful to you.",
      options: [
        { id: "conversation", label: "A live personal conversation", description: "Compare the five readers and choose who feels right for you.", scores: { "all-readers": 4, "alyssa-reading": 1 } },
        { id: "specialist", label: "A focused specialist reading", description: "A direct session centred on one question or intuitive concern.", scores: { "rhys-reading": 4, "psychic-reading": 1 } },
        { id: "report", label: "A detailed report to keep", description: "Written astrology you can revisit as events and timing unfold.", priority: 80, priorityResult: "all-reports", scores: { "all-reports": 4, "special-offer": 1 } },
        { id: "value", label: "Show me the best-value starting point", description: "Lead with the strongest current package in the report collection.", priority: 80, priorityResult: "special-offer", scores: { "special-offer": 4, "all-reports": 1 } }
      ]
    }
  ];

  var finderResults = [
    { id: "patrick-reading", eyebrow: "Best for personal timing", title: "Book a 1-to-1 astrology reading with Patrick", description: "Explore your birth chart, current cycles and the timing around a decision or life phase.", price: "GBP:From £175||USD:From $226 USD", href: "/products/patrick-consultation", cta: "View Patrick's consultation" },
    { id: "rhys-reading", eyebrow: "Best for one focused question", title: "Book a Horary astrology reading with Rhys", description: "A 30-minute live consultation in English or French, in which Rhys casts a chart for the moment your question is understood and gives one sincere issue his full attention.", price: "GBP:£120 / 30 minutes||USD:$165 USD / 30 minutes", href: "/products/rhys-consultation", cta: "View Rhys's consultation" },
    { id: "psychic-reading", eyebrow: "Best for intuitive guidance", title: "Explore psychic readings with Miriam and Robin", description: "Choose live mediumship, clairaudient guidance or Tarot-supported psychic insight. Robin also offers a £45 email option on her main page.", price: "GBP:From £45||USD:From $62 USD", href: "/pages/consultations#our-readers", cta: "Explore psychic readings" },
    { id: "alyssa-reading", eyebrow: "Best for personal growth", title: "Book spiritual life coaching with Alyssa", description: "A supportive conversation for emotional clarity, personal development and practical next steps, with Tarot where helpful.", price: "GBP:£80||USD:$110 USD", href: "/products/alyssa-consultation", cta: "View Alyssa's consultation" },
    { id: "special-offer", eyebrow: "Best-value written package", title: "Choose the current report special offer", description: "Combine a Life Road Map Report, 12 Month Forecast and Draconic Analysis in the strongest-value report package.", price: "GBP:£24.95||USD:$34.95 USD", href: "/products/character-analysis-free-transits-draconic-analysis", cta: "Get the special offer" },
    { id: "all-reports", eyebrow: "Best for written guidance", title: "Browse all personal astrology reports", description: "Compare forecasts, character analyses, relationship reports and specialist written astrology based on your birth details.", price: "Browse current prices", href: "/pages/reports#report-products", cta: "View all reports" },
    { id: "all-readers", eyebrow: "Best when you want to compare", title: "Meet all five readers", description: "Compare Patrick, Rhys, Miriam, Robin and Alyssa by approach, session type and the kind of question each reader handles.", price: "GBP:From £45||USD:From $62 USD", href: "/pages/consultations#our-readers", cta: "Compare all 1-to-1 readings" }
  ];

  function readFinderConfig(finder) {
    var configNode = finder.querySelector("[data-finder-config]");
    if (!configNode) return { questions: finderQuestions, results: finderResults };

    try {
      var parsed = JSON.parse(configNode.textContent);
      return {
        questions: Array.isArray(parsed.questions) && parsed.questions.length ? parsed.questions : finderQuestions,
        results: Array.isArray(parsed.results) && parsed.results.length ? parsed.results : finderResults
      };
    } catch (error) {
      return { questions: finderQuestions, results: finderResults };
    }
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (character) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[character];
    });
  }

  function getActiveCurrencyCode() {
    var localization = window.paStoreLocalization || {};
    return String(localization.currencyIsoCode || "").toUpperCase();
  }

  function localizePriceLabel(value) {
    var text = String(value || "");
    if (!text) return "";
    if (text.indexOf("||") === -1 && !/^[A-Za-z]{3}\s*:/.test(text)) return text;

    var activeCurrency = getActiveCurrencyCode();
    var fallback = "";
    var match = "";

    text.split("||").forEach(function (entry) {
      var cleaned = entry.trim();
      if (!cleaned) return;

      var parts = cleaned.match(/^([A-Za-z]{3})\s*:(.*)$/);
      if (!parts) {
        if (!fallback) fallback = cleaned;
        return;
      }

      var currency = parts[1].toUpperCase();
      var label = parts[2].trim();
      if (!fallback) fallback = label;
      if (currency === activeCurrency) match = label;
    });

    return match || fallback || text;
  }

  function recommend(answers, questions, results) {
    var scores = {};
    var strongestSupport = {};
    var latestSupport = {};
    var priorityMatch = null;

    questions.forEach(function (question, questionIndex) {
      var answer = answers[question.id];
      var option = question.options.find(function (candidate) {
        return candidate.id === answer;
      });
      if (!option) return;

      if (option.priorityResult) {
        var optionPriority = Number(option.priority) || 0;
        if (!priorityMatch || optionPriority > priorityMatch.priority || (optionPriority === priorityMatch.priority && questionIndex > priorityMatch.questionIndex)) {
          priorityMatch = {
            id: option.priorityResult,
            priority: optionPriority,
            questionIndex: questionIndex
          };
        }
      }

      Object.keys(option.scores).forEach(function (id) {
        var contribution = Number(option.scores[id]) || 0;
        scores[id] = (scores[id] || 0) + contribution;
        strongestSupport[id] = Math.max(strongestSupport[id] || 0, contribution);
        latestSupport[id] = questionIndex;
      });
    });

    var ranked = results.slice().sort(function (a, b) {
      var scoreDifference = (scores[b.id] || 0) - (scores[a.id] || 0);
      if (scoreDifference) return scoreDifference;

      var strengthDifference = (strongestSupport[b.id] || 0) - (strongestSupport[a.id] || 0);
      if (strengthDifference) return strengthDifference;

      var recencyDifference = (latestSupport[b.id] == null ? -1 : latestSupport[b.id]) - (latestSupport[a.id] == null ? -1 : latestSupport[a.id]);
      if (recencyDifference) return recencyDifference;

      return String(a.id || "").localeCompare(String(b.id || ""));
    });

    if (priorityMatch) {
      var priorityResult = ranked.find(function (result) {
        return result.id === priorityMatch.id;
      });
      if (priorityResult) {
        ranked = [priorityResult].concat(ranked.filter(function (result) {
          return result.id !== priorityMatch.id;
        }));
      }
    }

    return ranked;
  }

  function initFinder(scope) {
    var root = scope || document;
    var finders = [];

    if (root.matches && root.matches("[data-reading-finder]")) {
      finders.push(root);
    }

    root.querySelectorAll("[data-reading-finder]").forEach(function (finder) {
      finders.push(finder);
    });

    finders.forEach(function (finder) {
      var body = finder.querySelector("[data-finder-body]");
      var progress = finder.querySelector("[data-finder-progress]");
      var progressLabel = finder.querySelector("[data-finder-progress-label]");
      var headerRestart = finder.querySelector("[data-finder-header-restart]");
      if (!body || !progress || !progressLabel) return;
      if (finder._paFinderController && body.innerHTML.trim()) {
        finder._paFinderController.refresh();
        return;
      }

      var compareHref = finder.dataset.compareHref || "/collections/all";
      var compareLabel = finder.dataset.compareLabel || "Compare products";
      var questionNote = finder.dataset.questionNote || "No personal details are collected here. The quiz only guides you towards the most relevant reader, reading or written report.";
      var resultReadyLabel = finder.dataset.resultReadyLabel || "Result ready";
      var resultNote = finder.dataset.resultNote || "Want to compare another route? Change your answers and refresh the recommendation.";
      var bestMatchLabel = finder.dataset.bestMatchLabel || "Best match";
      var suggestedOptionsLabel = finder.dataset.suggestedOptionsLabel || "Suggested options";
      var startAgainLabel = finder.dataset.startAgainLabel || "Start again";
      var backLabel = finder.dataset.backLabel || "Back";
      var nextLabel = finder.dataset.nextLabel || "Next";
      var showRecommendationLabel = finder.dataset.showRecommendationLabel || "Show recommendation";
      var progressQuestionLabel = finder.dataset.progressQuestionLabel || "Question";
      var progressOfLabel = finder.dataset.progressOfLabel || "of";
      var config = readFinderConfig(finder);
      var questions = config.questions;
      var results = config.results;
      var answers = {};
      var index = 0;

      function renderQuestion() {
        var question = questions[index];
        finder.classList.remove("is-result");
        finder.classList.add("is-question");
        progress.style.width = Math.round((index / questions.length) * 100) + "%";
        progressLabel.textContent = progressQuestionLabel + " " + (index + 1) + " " + progressOfLabel + " " + questions.length;
        if (headerRestart) headerRestart.hidden = true;
        body.innerHTML = [
          '<div class="finder-question-grid">',
          '<div class="finder-question-copy"><div class="finder-panel-inner"><div class="finder-copy-frame"><h2>' + escapeHtml(question.prompt) + '</h2><p>' + escapeHtml(question.helper) + '</p></div></div><div class="finder-panel-note"><p>' + escapeHtml(questionNote) + '</p></div></div>',
          '<div class="finder-options">' + question.options.map(function (option) {
            var selected = answers[question.id] === option.id;
            return '<button aria-pressed="' + selected + '" class="' + (selected ? "is-selected" : "") + '" data-option="' + escapeHtml(option.id) + '" type="button"><span class="finder-option-content"><span><span class="finder-option-label">' + escapeHtml(option.label) + '</span><small>' + escapeHtml(option.description) + '</small></span><span aria-hidden="true" class="finder-option-check"><svg fill="none" viewBox="0 0 16 16"><path d="M3.5 8.4 6.5 11 12.5 5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg></span></span></button>';
          }).join("") + '</div>',
          '</div>',
          '<div class="finder-footer"><button ' + (index === 0 ? "disabled" : "") + ' data-finder-back type="button">' + escapeHtml(backLabel) + '</button><button ' + (!answers[question.id] ? "disabled" : "") + ' data-finder-next type="button">' + escapeHtml(index === questions.length - 1 ? showRecommendationLabel : nextLabel) + '</button></div>'
        ].join("");
      }

      function renderResult() {
        var ranked = recommend(answers, questions, results);
        var primary = ranked[0];
        var alternatives = ranked.slice(1, 3);
        if (!primary) return;
        var primaryPrice = localizePriceLabel(primary.price);
        var primaryImage = primary.image ? '<div class="finder-result-media"><img alt="' + escapeHtml(primary.imageAlt || "") + '" height="320" loading="lazy" src="' + escapeHtml(primary.image) + '" width="320"></div>' : "";
        finder.classList.remove("is-question");
        finder.classList.add("is-result");
        progress.style.width = "100%";
        progressLabel.textContent = resultReadyLabel;
        if (headerRestart) headerRestart.hidden = false;
        body.innerHTML = [
          '<div class="finder-result-grid">',
          '<div class="finder-result-primary"><div class="finder-result-main">' + primaryImage + '<div class="finder-copy-frame"><p class="eyebrow">' + escapeHtml(primary.eyebrow) + '</p><h2>' + escapeHtml(primary.title) + '</h2><p>' + escapeHtml(primary.description) + '</p><div class="finder-price-row"><span>' + escapeHtml(primaryPrice) + '</span><strong>' + escapeHtml(bestMatchLabel) + '</strong></div></div><div class="finder-result-actions"><a class="button button-dark" href="' + escapeHtml(primary.href || compareHref) + '">' + escapeHtml(primary.cta) + '</a><a class="button button-outline" href="' + escapeHtml(compareHref) + '">' + escapeHtml(compareLabel) + '</a></div></div><div class="finder-panel-note"><p>' + escapeHtml(resultNote) + '</p></div></div>',
          '<div class="finder-result-options"><div><div class="finder-result-toolbar"><p class="eyebrow">' + escapeHtml(suggestedOptionsLabel) + '</p></div><ul class="finder-result-list">',
          [primary].concat(alternatives).map(function (result, resultIndex) {
            var resultImage = result.image ? '<span class="finder-result-card-image"><img alt="" height="120" loading="lazy" src="' + escapeHtml(result.image) + '" width="120"></span>' : "";
            var resultStatus = resultIndex === 0 ? bestMatchLabel : suggestedOptionsLabel.replace(/s$/i, "");
            return '<li><a ' + (resultIndex === 0 ? 'aria-current="true" ' : "") + 'class="finder-result-card ' + (resultIndex === 0 ? "is-primary" : "") + '" href="' + escapeHtml(result.href || compareHref) + '">' + resultImage + '<span class="finder-result-card-copy"><span class="finder-result-card-status">' + escapeHtml(resultStatus) + '</span><strong>' + escapeHtml(result.title) + '</strong><small>' + escapeHtml(result.description) + '</small><em>' + escapeHtml(localizePriceLabel(result.price)) + '</em></span></a></li>';
          }).join(""),
          '</ul></div></div>',
          '</div>'
        ].join("");
      }

      body.addEventListener("click", function (event) {
        var option = event.target.closest("[data-option]");
        if (option) {
          answers[questions[index].id] = option.dataset.option;
          renderQuestion();
          return;
        }
        if (event.target.closest("[data-finder-back]")) {
          index = Math.max(index - 1, 0);
          renderQuestion();
          return;
        }
        if (event.target.closest("[data-finder-next]")) {
          if (index === questions.length - 1) {
            renderResult();
          } else {
            index += 1;
            renderQuestion();
          }
          return;
        }
        if (event.target.closest("[data-finder-restart]")) {
          answers = {};
          index = 0;
          renderQuestion();
        }
      });
      if (headerRestart) {
        headerRestart.addEventListener("click", function () {
          answers = {};
          index = 0;
          renderQuestion();
        });
      }

      finder._paFinderController = {
        refresh: renderQuestion
      };
      renderQuestion();
    });
  }

  function initReadingTabs() {
    document.querySelectorAll("[data-reading-conversion]").forEach(function (root) {
      root.querySelectorAll("[data-reading-tab]").forEach(function (tab) {
        tab.addEventListener("click", function () {
          var mode = tab.dataset.readingTab;
          root.querySelectorAll("[data-reading-tab]").forEach(function (candidate) {
            var active = candidate.dataset.readingTab === mode;
            candidate.classList.toggle("is-active", active);
            candidate.setAttribute("aria-selected", active ? "true" : "false");
          });
          root.querySelectorAll("[data-reading-panel]").forEach(function (panel) {
            panel.hidden = panel.dataset.readingPanel !== mode;
          });
        });
      });
    });
  }

  function initReaderFilters(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-reader-directory]").forEach(function (directory) {
      if (directory.dataset.paReaderFiltersReady === "true") return;
      directory.dataset.paReaderFiltersReady = "true";

      var buttons = Array.from(directory.querySelectorAll("[data-reader-filter]"));
      var viewButtons = Array.from(directory.querySelectorAll("[data-reader-view]"));
      var cards = Array.from(directory.querySelectorAll("[data-reader-card]"));
      var results = directory.querySelector("[data-reader-results]");
      var status = directory.querySelector("[data-reader-filter-status]");
      var labels = {
        all: "all five readers",
        natal: "Natal Astrology",
        horary: "Horary Astrology",
        coaching: "Spiritual Life Coaching",
        "psychic-tarot": "Psychic & Tarot",
        mediumship: "Psychic Mediumship"
      };
      var heightFrame = 0;

      function syncGridCardHeights() {
        if (heightFrame) window.cancelAnimationFrame(heightFrame);
        heightFrame = window.requestAnimationFrame(function () {
          heightFrame = 0;
          var cardMains = cards.map(function (card) {
            return card.querySelector(".reader-directory-card-main");
          }).filter(Boolean);
          cardMains.forEach(function (main) {
            main.style.minHeight = "";
          });
          if (!results || !results.classList.contains("is-grid")) return;
          var visibleMains = cards.filter(function (card) {
            return !card.hidden;
          }).map(function (card) {
            return card.querySelector(".reader-directory-card-main");
          }).filter(Boolean);
          var tallest = visibleMains.reduce(function (height, main) {
            return Math.max(height, Math.ceil(main.getBoundingClientRect().height));
          }, 0);
          visibleMains.forEach(function (main) {
            main.style.minHeight = tallest + "px";
          });
        });
      }

      function applyFilter(filter) {
        var visibleCount = 0;
        cards.forEach(function (card) {
          var services = (card.dataset.readerServices || "").split(" ");
          var visible = filter === "all" || services.indexOf(filter) !== -1;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        buttons.forEach(function (button) {
          button.setAttribute("aria-pressed", button.dataset.readerFilter === filter ? "true" : "false");
        });
        if (status) {
          status.textContent = filter === "all"
            ? "Showing all five readers"
            : "Showing " + visibleCount + " " + labels[filter] + (visibleCount === 1 ? " reader" : " readers");
        }
        syncGridCardHeights();
      }

      function applyView(view) {
        var activeView = view === "grid" ? "grid" : "list";
        if (results) {
          results.classList.toggle("is-list", activeView === "list");
          results.classList.toggle("is-grid", activeView === "grid");
        }
        viewButtons.forEach(function (button) {
          button.setAttribute("aria-pressed", button.dataset.readerView === activeView ? "true" : "false");
        });
        syncGridCardHeights();
      }

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          applyView("list");
          applyFilter(button.dataset.readerFilter || "all");
        });
      });
      viewButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          applyView(button.dataset.readerView || "list");
        });
      });
      window.addEventListener("resize", syncGridCardHeights);
      directory.querySelectorAll("img").forEach(function (image) {
        if (!image.complete) image.addEventListener("load", syncGridCardHeights, { once: true });
      });
      if (window.MutationObserver && results) {
        new MutationObserver(syncGridCardHeights).observe(results, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
      applyView("list");
      applyFilter("all");
    });
  }

  function initReadingComparisonScroll(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-reading-comparison]").forEach(function (shell) {
      if (shell.dataset.paReadingComparisonReady === "true") return;
      shell.dataset.paReadingComparisonReady = "true";
      var scroller = shell.querySelector(".reading-comparison-scroll");
      var nextButton = shell.querySelector("[data-reading-comparison-next]");
      var cue = shell.querySelector(".reading-comparison-scroll-cue");
      if (!scroller || !nextButton || !cue) return;

      function updateScrollCue() {
        var remaining = scroller.scrollWidth - scroller.clientWidth - scroller.scrollLeft;
        var canScrollRight = remaining > 8;
        shell.classList.toggle("is-scrollable", canScrollRight);
        cue.setAttribute("aria-hidden", canScrollRight ? "false" : "true");
        nextButton.tabIndex = canScrollRight ? 0 : -1;
      }

      nextButton.addEventListener("click", function () {
        scroller.scrollBy({
          left: Math.max(280, scroller.clientWidth * 0.72),
          behavior: "smooth"
        });
      });
      scroller.addEventListener("scroll", updateScrollCue, { passive: true });
      window.addEventListener("resize", updateScrollCue);
      if (typeof ResizeObserver !== "undefined") {
        var observer = new ResizeObserver(updateScrollCue);
        observer.observe(scroller);
      }
      requestAnimationFrame(updateScrollCue);
    });
  }

  function initTestimonialCarousels(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-testimonial-carousel]").forEach(function (carousel) {
      if (carousel.dataset.paTestimonialCarouselReady === "true") return;
      carousel.dataset.paTestimonialCarouselReady = "true";

      var track = carousel.querySelector("[data-testimonial-track]");
      var previous = carousel.querySelector("[data-testimonial-previous]");
      var next = carousel.querySelector("[data-testimonial-next]");
      if (!track || !previous || !next) return;

      function updateControls() {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= maxScroll - 4;
      }

      function scrollTestimonials(direction) {
        var card = track.querySelector(".product-testimonial-card");
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 16;
        var distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        track.scrollBy({ left: direction * distance, behavior: "smooth" });
      }

      previous.addEventListener("click", function () { scrollTestimonials(-1); });
      next.addEventListener("click", function () { scrollTestimonials(1); });
      track.addEventListener("scroll", updateControls, { passive: true });
      window.addEventListener("resize", updateControls);
      if (typeof ResizeObserver !== "undefined") {
        var observer = new ResizeObserver(updateControls);
        observer.observe(track);
      }
      requestAnimationFrame(updateControls);
    });
  }

  function initCatalogueFilters(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-product-catalogue]").forEach(function (catalogue) {
      if (catalogue.dataset.paCatalogueFiltersReady === "true") return;
      catalogue.dataset.paCatalogueFiltersReady = "true";

      var buttons = Array.from(catalogue.querySelectorAll("[data-catalogue-filter]"));
      var items = Array.from(catalogue.querySelectorAll("[data-catalogue-item]"));
      var groups = Array.from(catalogue.querySelectorAll("[data-catalogue-group]"));
      var status = catalogue.querySelector("[data-catalogue-filter-status]");
      var labels = {
        all: "all readings, reports and gifts",
        readings: "all 1-to-1 readings",
        natal: "Natal astrology readings",
        recorded: "recorded video readings",
        horary: "Horary astrology readings",
        tarot: "psychic and Tarot readings",
        mediumship: "psychic mediumship readings",
        coaching: "spiritual coaching readings",
        reports: "written astrology reports",
        gifts: "gifts and membership"
      };

      function applyFilter(filter) {
        var visibleCount = 0;
        items.forEach(function (item) {
          var filters = (item.dataset.catalogueFilters || "").split(" ");
          var visible = filter === "all" || filters.indexOf(filter) !== -1;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        groups.forEach(function (group) {
          group.hidden = !group.querySelector("[data-catalogue-item]:not([hidden])");
        });

        buttons.forEach(function (button) {
          button.setAttribute("aria-pressed", button.dataset.catalogueFilter === filter ? "true" : "false");
        });

        if (status) {
          status.textContent = "Showing " + labels[filter] + " (" + visibleCount + ")";
        }
      }

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          applyFilter(button.dataset.catalogueFilter || "all");
        });
      });

      applyFilter("all");
    });
  }

  function initReportFilters(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-report-directory]").forEach(function (directory) {
      if (directory.dataset.paReportFiltersReady === "true") return;
      directory.dataset.paReportFiltersReady = "true";

      var buttons = Array.from(directory.querySelectorAll("[data-report-filter]"));
      var items = Array.from(directory.querySelectorAll("[data-report-item]"));
      var status = directory.querySelector("[data-report-filter-status]");
      var labels = {
        forecast: "forecast reports",
        character: "character analyses",
        relationship: "relationship reports",
        tarot: "Tarot readings",
        specialist: "specialist reports and tools"
      };

      function applyFilter(filter) {
        var visibleCount = 0;
        items.forEach(function (item) {
          var filters = (item.dataset.reportFilters || "").split(" ");
          var visible = filter === "all" || filters.indexOf(filter) !== -1;
          item.toggleAttribute("data-report-hidden", !visible);
          if (visible) visibleCount += 1;
        });

        buttons.forEach(function (button) {
          button.setAttribute("aria-pressed", button.dataset.reportFilter === filter ? "true" : "false");
        });

        if (status) {
          status.textContent = filter === "all"
            ? "Showing all reports and Tarot options (" + visibleCount + ")"
            : "Showing " + labels[filter] + " (" + visibleCount + ")";
        }
      }

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          applyFilter(button.dataset.reportFilter || "all");
        });
      });

      applyFilter("all");
    });
  }

  function initReaderSessionPickers(scope) {
    var root = scope || document;
    if (document.documentElement.dataset.paReaderSessionDismissReady !== "true") {
      document.documentElement.dataset.paReaderSessionDismissReady = "true";
      document.addEventListener("pointerdown", function (event) {
        document.querySelectorAll("[data-reader-session-menu][open]").forEach(function (openMenu) {
          if (!openMenu.contains(event.target)) openMenu.open = false;
        });
      });
      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        document.querySelectorAll("[data-reader-session-menu][open]").forEach(function (openMenu) {
          openMenu.open = false;
          var summary = openMenu.querySelector("summary");
          if (summary) summary.focus();
        });
      });
    }
    root.querySelectorAll("[data-reader-session-picker]").forEach(function (picker) {
      if (picker.dataset.paSessionPickerReady === "true") return;
      picker.dataset.paSessionPickerReady = "true";
      var menu = picker.querySelector("[data-reader-session-menu]");
      var title = picker.querySelector("[data-reader-session-title]");
      var price = picker.querySelector("[data-reader-session-price]");
      var form = picker.closest("form");
      var bookingLink = form && form.querySelector("[data-reader-booking-page-link]");
      var bookingLinkLabel = bookingLink && bookingLink.querySelector("span");
      var options = Array.from(picker.querySelectorAll('input[name="id"]'));

      function updateSelection(input, closeMenu) {
        if (!input) return;
        if (title) title.textContent = input.dataset.sessionTitle || "Choose session";
        if (price) price.textContent = input.dataset.sessionPrice || "";
        if (bookingLink && input.dataset.sessionUrl) bookingLink.href = input.dataset.sessionUrl;
        if (bookingLinkLabel && input.dataset.sessionLinkLabel) bookingLinkLabel.textContent = input.dataset.sessionLinkLabel;
        if (closeMenu && menu) menu.open = false;
      }

      options.forEach(function (input) {
        input.addEventListener("change", function () {
          if (input.checked) updateSelection(input, true);
        });
      });
      updateSelection(options.find(function (input) { return input.checked; }), false);
    });
  }

  function initTarotPicker() {
    document.querySelectorAll("[data-tarot-picker]").forEach(function (root) {
      var title = root.querySelector("[data-tarot-title]");
      root.querySelectorAll("[data-tarot-tab]").forEach(function (tab) {
        tab.addEventListener("click", function () {
          var id = tab.dataset.tarotTab;
          root.querySelectorAll("[data-tarot-tab]").forEach(function (candidate) {
            var active = candidate.dataset.tarotTab === id;
            candidate.classList.toggle("is-active", active);
            candidate.setAttribute("aria-selected", active ? "true" : "false");
          });
          root.querySelectorAll("[data-tarot-panel]").forEach(function (panel) {
            panel.hidden = panel.dataset.tarotPanel !== id;
          });
          if (title) title.textContent = tab.querySelector("strong").textContent;
        });
      });
    });
  }

  function initConsultationBooking() {
    var root = document.querySelector("[data-consultation-booking]");
    if (!root) return;
    var title = root.querySelector("[data-consultation-title]");
    var summary = root.querySelector("[data-consultation-summary]");
    var variant = root.querySelector("[data-consultation-variant]");
    var submit = root.querySelector("[data-consultation-submit]");
    var format = root.querySelector("[data-consultation-format]");
    var patrickFormats = Array.from(root.querySelectorAll("[data-patrick-format]"));
    var alyssaFormats = Array.from(root.querySelectorAll("[data-alyssa-format]"));
    var data = {
      patrick: {
        name: "Patrick Arundell",
        label: "Astrology consultation",
        title: "1-to-1 astrology with Patrick",
        price: root.dataset.patrickPrice || "GBP:From £175||USD:From $226 USD",
        summary: "A prepared live one-to-one video consultation via Zoom, matched to the service you select."
      },
      alyssa: {
        name: "Alyssa Arundell",
        label: "Tarot and intuitive guidance",
        title: "1-to-1 guidance with Alyssa",
        price: root.dataset.alyssaPrice || "GBP:£80 / 1 hour||USD:$110 USD / 1 hour",
        summary: "Choose a one-hour live session or a private one-way recorded video for relationships, choices and next steps."
      }
    };

    function selectReader(reader) {
      var item = data[reader] || data.patrick;
      document.querySelectorAll("[data-consultation-offer]").forEach(function (card) {
        card.classList.toggle("is-selected", card.dataset.consultationOffer === reader);
      });
      root.querySelectorAll("[data-reader-radio]").forEach(function (radio) {
        radio.checked = radio.dataset.reader === reader;
      });
      if (title) title.textContent = "Send your request for " + item.name;
      if (summary) {
        summary.innerHTML = "<span>" + item.label + "</span><strong>" + item.title + "</strong><em>" + escapeHtml(localizePriceLabel(item.price)) + "</em><p>" + item.summary + "</p>";
      }
      var radio = root.querySelector('[data-reader-radio][data-reader="' + reader + '"]');
      if (variant && radio && radio.dataset.variantId) {
        variant.value = radio.dataset.variantId;
      }
      patrickFormats.forEach(function (option) {
        option.hidden = reader === "alyssa";
        option.disabled = reader === "alyssa";
      });
      alyssaFormats.forEach(function (option) {
        option.hidden = reader !== "alyssa";
        option.disabled = reader !== "alyssa";
      });
      if (format) format.value = reader === "alyssa" ? "Live video call" : "Zoom video call";
      if (submit) submit.textContent = "Continue with " + item.name.split(" ")[0] + " request";
    }

    document.querySelectorAll("[data-start-consultation]").forEach(function (button) {
      button.addEventListener("click", function () {
        selectReader(button.dataset.startConsultation);
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    root.querySelectorAll("[data-reader-radio]").forEach(function (radio) {
      radio.addEventListener("change", function () {
        selectReader(radio.dataset.reader);
      });
    });
  }

  function closeCartDetailsModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("has-cart-details-modal-open");
    document.documentElement.style.overflow = "";
    if (modal._paLastFocus && typeof modal._paLastFocus.focus === "function") {
      modal._paLastFocus.focus();
    }
  }

  function openCartDetailsModal(modal, opener) {
    if (!modal) return;
    document.querySelectorAll("[data-cart-details-modal]").forEach(function (candidate) {
      if (candidate !== modal) closeCartDetailsModal(candidate);
    });
    modal._paLastFocus = opener;
    modal.hidden = false;
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("has-cart-details-modal-open");
    document.documentElement.style.overflow = "hidden";
    var focusTarget = modal.querySelector("[data-cart-modal-close], input, select, textarea, button");
    if (focusTarget) focusTarget.focus();
  }

  function initCartDetailsModals(scope) {
    var root = scope || document;
    var openers = [];

    if (root.matches && root.matches("[data-cart-modal-open]")) {
      openers.push(root);
    }

    root.querySelectorAll("[data-cart-modal-open]").forEach(function (button) {
      openers.push(button);
    });

    openers.forEach(function (button) {
      if (button.dataset.paCartModalReady === "true") return;
      button.dataset.paCartModalReady = "true";
      button.addEventListener("click", function () {
        var modal = document.getElementById(button.getAttribute("data-cart-modal-open"));
        openCartDetailsModal(modal, button);
      });
    });

    root.querySelectorAll("[data-cart-details-modal]").forEach(function (modal) {
      if (modal.dataset.paCartModalReady === "true") return;
      modal.dataset.paCartModalReady = "true";
      modal.querySelectorAll("[data-cart-modal-close]").forEach(function (button) {
        button.addEventListener("click", function () {
          closeCartDetailsModal(modal);
        });
      });
      modal.addEventListener("input", function (event) {
        var field = event.target;
        if (field && field.matches && field.matches("[required]") && String(field.value || "").trim() !== "") {
          field.removeAttribute("aria-invalid");
        }
      });
    });

    root.querySelectorAll("[data-cart-line-details-submit]").forEach(function (button) {
      if (button.dataset.paCartLineDetailsReady === "true") return;
      button.dataset.paCartLineDetailsReady = "true";
      button.addEventListener("click", function () {
        var detailsForm = button.closest("[data-cart-line-details-form]");
        if (!detailsForm) return;

        var itemKeyInput = detailsForm.querySelector("[name='item_key']");
        var lineInput = detailsForm.querySelector("[name='line']");
        var quantityInput = detailsForm.querySelector("[name='quantity']");
        var error = detailsForm.querySelector("[data-cart-details-error]");
        var properties = collectLineItemProperties(detailsForm);
        var hasVisibleProperties = false;
        var missingRequiredFields = [];
        var recipientChoice = detailsForm.querySelector("[data-cart-recipient-choice] input[type='radio']:checked");
        var recipientMode = recipientChoice ? recipientChoice.value : "shared";

        Object.keys(properties).forEach(function (propertyName) {
          if (propertyName.charAt(0) !== "_") hasVisibleProperties = true;
        });

        detailsForm.querySelectorAll("[required]").forEach(function (field) {
          if (field.disabled) return;
          var isUncheckedChoice = (field.type === "radio" || field.type === "checkbox") && !field.checked;
          if (isUncheckedChoice || String(field.value || "").trim() === "") {
            field.setAttribute("aria-invalid", "true");
            missingRequiredFields.push(field);
          } else {
            field.removeAttribute("aria-invalid");
          }
        });

        var quantity = Number(quantityInput && quantityInput.value) || 1;
        properties._details_mode = recipientMode;
        properties._details_people_count = recipientMode === "separate" ? String(quantity) : "1";

        if (!hasVisibleProperties || missingRequiredFields.length) {
          if (error) {
            error.textContent = missingRequiredFields.length
              ? "Complete the highlighted required fields before saving. Birth time can be left blank when it is not known."
              : "Add at least one detail before saving.";
            error.hidden = false;
          }
          if (missingRequiredFields.length) {
            missingRequiredFields[0].focus();
            missingRequiredFields[0].scrollIntoView({ behavior: "smooth", block: "center" });
          }
          return;
        }

        if (error) {
          error.hidden = true;
          error.textContent = "";
        }

        button.disabled = true;
        button.textContent = "Saving...";

        var rootPath = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
        var line = Number(lineInput && lineInput.value);
        var itemKey = itemKeyInput ? itemKeyInput.value : "";
        var currentLine = line;

        function parseCartChangeResponse(response) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            if (!response.ok) {
              throw new Error(payload.description || payload.message || "Shopify could not update this cart item.");
            }
            return payload;
          });
        }

        fetch(rootPath + "cart.js", { headers: { Accept: "application/json" } })
          .then(function (response) {
            if (!response.ok) throw new Error("Unable to load the cart.");
            return response.json();
          })
          .then(function (cart) {
            var currentItem = itemKey
              ? cart.items.find(function (item) { return item.key === itemKey; })
              : cart.items[line - 1];
            if (!currentItem) throw new Error("This cart item could not be found.");
            currentLine = cart.items.indexOf(currentItem) + 1;
            var preservedProperties = {};
            Object.keys(currentItem.properties || {}).forEach(function (key) {
              if (key === "Gift for someone else") preservedProperties[key] = currentItem.properties[key];
              if (["Reports included", "Synastry chart system", "Composite chart system"].indexOf(key) !== -1) {
                preservedProperties[key] = currentItem.properties[key];
              }
              if (key.charAt(0) === "_" && key !== "_details_mode" && key !== "_details_people_count") {
                preservedProperties[key] = currentItem.properties[key];
              }
            });
            return fetch(rootPath + "cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: JSON.stringify({
                id: currentItem.key,
                properties: Object.assign(preservedProperties, properties)
              })
            }).then(function (response) {
              if (response.ok) return parseCartChangeResponse(response);
              return fetch(rootPath + "cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json"
                },
                body: JSON.stringify({
                  line: currentLine,
                  properties: Object.assign(preservedProperties, properties)
                })
              }).then(parseCartChangeResponse);
            });
          })
          .then(function (cart) {
            var saved = (cart.items || []).some(function (item) {
              return Object.keys(properties).every(function (key) {
                return String((item.properties || {})[key] || "") === String(properties[key]);
              });
            });
            if (!saved) throw new Error("The details were not returned with the cart item.");
            window.location.reload();
          })
          .catch(function (saveError) {
            button.disabled = false;
            button.textContent = "Save details";
            if (error) {
              error.textContent = saveError && saveError.message
                ? saveError.message
                : "The details could not be saved. Please try again.";
              error.hidden = false;
            }
          });
      });
    });

    root.querySelectorAll("[data-cart-checkout-button]").forEach(function (button) {
      if (button.dataset.paCartCheckoutReady === "true") return;
      button.dataset.paCartCheckoutReady = "true";
      button.addEventListener("click", function (event) {
        if (button.dataset.paCheckoutAllowed === "true") return;
        var cartForm = button.closest("form");
        var quantityChanged = cartForm && Array.from(cartForm.querySelectorAll("input[name='updates[]']")).some(function (input) {
          return String(input.value) !== String(input.defaultValue);
        });
        if (quantityChanged) {
          event.preventDefault();
          var updateButton = cartForm.querySelector("button[name='update']");
          if (updateButton) updateButton.click();
          return;
        }
        var prompt = document.getElementById("cart-details-checkout-prompt");
        if (!prompt) return;
        event.preventDefault();
        openCartDetailsModal(prompt, button);
      });
    });

    root.querySelectorAll("[data-cart-continue-checkout]").forEach(function (button) {
      if (button.dataset.paCartContinueCheckoutReady === "true") return;
      button.dataset.paCartContinueCheckoutReady = "true";
      button.addEventListener("click", function () {
        var checkoutButton = document.querySelector("[data-cart-checkout-button]");
        if (!checkoutButton) return;
        checkoutButton.dataset.paCheckoutAllowed = "true";
        checkoutButton.click();
      });
    });

    if (document.documentElement.dataset.paCartModalKeyboardReady === "true") return;
    document.documentElement.dataset.paCartModalKeyboardReady = "true";
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      document.querySelectorAll("[data-cart-details-modal]").forEach(function (modal) {
        if (!modal.hidden) closeCartDetailsModal(modal);
      });
    });
  }

  function initProductComparison() {
    if (document.documentElement.dataset.paComparisonReady === "true") {
      if (window.paSyncProductComparisonButtons) window.paSyncProductComparisonButtons();
      return;
    }

    var dialog = document.querySelector("[data-comparison-dialog]");
    var launcher = document.querySelector("[data-comparison-launcher]");
    var dock = document.querySelector("[data-comparison-dock]");
    if (!dialog || !launcher || !dock) return;

    document.documentElement.dataset.paComparisonReady = "true";
    var comparisonStorageKey = "patrick-store-product-comparison";
    var maximumItems = 4;
    var selectedItems = readComparisonItems();
    var lastLauncher = null;
    var productRegionVisible = false;
    var dockDismissed = false;
    var comparisonCatalog = document.querySelector("[data-comparison-catalog]");

    function escapeComparisonHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function safeComparisonUrl(value) {
      var url = String(value || "");
      return /^\/(products|pages|collections)\//.test(url) ? url : "/collections/all";
    }

    function safeComparisonImage(value) {
      var url = String(value || "");
      return /^(?:https?:)?\/\//.test(url) || /^\//.test(url) ? url : "";
    }

    function normaliseComparisonHandle(value) {
      return String(value || "").trim().toLowerCase();
    }

    function comparisonHandleFromUrl(value) {
      var match = String(value || "").match(/(?:^|\/)products\/([^/?#]+)/i);
      return match ? normaliseComparisonHandle(match[1]) : "";
    }

    function safeVariantId(value) {
      var variantId = String(value || "").trim();
      return /^\d+$/.test(variantId) ? variantId : "";
    }

    function safeCartPath(value, fallback) {
      var url = String(value || "");
      return /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?cart(?:\/add)?(?:$|[/?#])/.test(url) ? url : fallback;
    }

    function readComparisonItems() {
      try {
        var parsed = JSON.parse(localStorage.getItem(comparisonStorageKey) || "[]");
        if (!Array.isArray(parsed)) return [];
        return parsed.reduce(function (items, item) {
          var handle = comparisonHandleFromUrl(item && item.url) || normaliseComparisonHandle(item && item.handle);
          if (!handle || items.some(function (entry) { return entry.handle === handle; }) || items.length >= maximumItems) return items;
          items.push(Object.assign({}, item, {
            handle: handle,
            url: safeComparisonUrl(item.url),
            image: safeComparisonImage(item.image),
            variantId: safeVariantId(item.variantId)
          }));
          return items;
        }, []);
      } catch (error) {
        return [];
      }
    }

    function saveComparisonItems() {
      try {
        localStorage.setItem(comparisonStorageKey, JSON.stringify(selectedItems));
      } catch (error) {}
    }

    function itemFromButton(button) {
      var handle = comparisonHandleFromUrl(button.dataset.compareUrl) || normaliseComparisonHandle(button.dataset.compareHandle);
      if (!handle) return null;
      return {
        handle: handle,
        title: button.dataset.compareTitle || "Product",
        url: safeComparisonUrl(button.dataset.compareUrl),
        price: button.dataset.comparePrice || "See product",
        type: button.dataset.compareType || "Astrology product",
        description: button.dataset.compareDescription || "See the product page for full details.",
        includes: button.dataset.compareIncludes || "",
        image: safeComparisonImage(button.dataset.compareImage),
        format: button.dataset.compareFormat || "See product details",
        requirements: button.dataset.compareRequirements || "See product details",
        delivery: button.dataset.compareDelivery || "See product details",
        variantId: safeVariantId(button.dataset.compareVariantId),
        available: button.dataset.compareAvailable === "true",
        requiresDetails: button.dataset.compareRequiresDetails !== "false",
        enquiryOnly: button.dataset.compareEnquiryOnly === "true"
      };
    }

    function itemFromPicker(option) {
      var handle = normaliseComparisonHandle(option && option.value);
      if (!handle) return null;
      return {
        handle: handle,
        title: option.dataset.title || option.textContent || "Product",
        url: safeComparisonUrl(option.dataset.url),
        price: option.dataset.price || "See product",
        type: option.dataset.type || "Astrology product",
        description: option.dataset.description || "See the product page for full details.",
        includes: option.dataset.includes || "",
        image: safeComparisonImage(option.dataset.image),
        format: option.dataset.format || "See product details",
        requirements: option.dataset.requirements || "See product details",
        delivery: option.dataset.delivery || "See product details",
        variantId: safeVariantId(option.dataset.variantId),
        available: option.dataset.available === "true",
        requiresDetails: option.dataset.requiresDetails !== "false",
        enquiryOnly: option.dataset.enquiryOnly === "true"
      };
    }

    function selectedIndex(handle) {
      return selectedItems.findIndex(function (item) { return item.handle === handle; });
    }

    function syncProductComparisonButtons() {
      var full = selectedItems && selectedItems.length >= maximumItems;
      document.querySelectorAll("[data-compare-product]").forEach(function (button) {
        var buttonItem = itemFromButton(button);
        var buttonHandle = buttonItem ? buttonItem.handle : "";
        var activeIndex = buttonHandle ? selectedIndex(buttonHandle) : -1;
        var active = activeIndex !== -1;
        if (active) selectedItems[activeIndex] = Object.assign({}, selectedItems[activeIndex], buttonItem);
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
        button.disabled = !active && full;
        var label = button.querySelector("[data-compare-label]");
        if (label) label.textContent = "Compare";
        var title = button.dataset.compareTitle || "this product";
        button.setAttribute("aria-label", active ? "Remove " + title + " from comparison" : full ? "Comparison is full" : "Compare " + title);
        button.title = active ? "Remove from comparison" : full ? "Comparison is full" : "Compare";
      });
    }
    window.paSyncProductComparisonButtons = syncProductComparisonButtons;

    function includesMarkup(value) {
      var values = String(value || "").split("||").filter(Boolean).slice(0, 4);
      if (!values.length) return "See the product page for the complete contents.";
      return "<ul>" + values.map(function (entry) { return "<li>" + escapeComparisonHtml(entry) + "</li>"; }).join("") + "</ul>";
    }

    function tableCellValue(item, key) {
      if (key === "includes") return includesMarkup(item[key]);
      return escapeComparisonHtml(item[key]);
    }

    function renderComparison() {
      syncProductComparisonButtons();
      var count = selectedItems.length;
      var countNode = launcher.querySelector("[data-comparison-count]");
      var launcherLabel = launcher.querySelector("[data-comparison-launcher-label]");
      var status = dialog.querySelector("[data-comparison-status]");
      var tableTarget = dialog.querySelector("[data-comparison-table]");
      var bundle = dialog.querySelector("[data-comparison-bundle]");
      var dockItems = dock.querySelector("[data-comparison-dock-items]");

      dock.hidden = count === 0 || dockDismissed;
      if (countNode) {
        countNode.textContent = String(count);
        countNode.hidden = count === 0;
      }
      if (launcherLabel) launcherLabel.textContent = "Compare";
      if (dockItems) {
        dockItems.innerHTML = selectedItems.map(function (item) {
          var image = item.image ? '<img src="' + escapeComparisonHtml(item.image) + '" alt="" width="44" height="44">' : '<span class="product-comparison-dock-placeholder" aria-hidden="true"></span>';
          return '<div class="product-comparison-dock-item">' + image + '<span>' + escapeComparisonHtml(item.title) + '</span><button type="button" data-comparison-remove="' + escapeComparisonHtml(item.handle) + '" aria-label="Remove ' + escapeComparisonHtml(item.title) + ' from comparison">×</button></div>';
        }).join("");
      }
      if (status) status.textContent = count ? count + (count === 1 ? " product selected" : " products selected") + (count < maximumItems ? ". Add up to " + (maximumItems - count) + " more." : ".") : "Choose up to four products.";
      if (tableTarget) tableTarget.hidden = false;

      var bundleHandles = ["natal-character-analysis", "12-month-personal-horoscope-forecast", "draconic-character-analysis"];
      var bundleMatches = selectedItems.filter(function (item) { return bundleHandles.indexOf(item.handle) !== -1; });
      var hasOffer = selectedIndex("character-analysis-free-transits-draconic-analysis") !== -1;
      if (bundle) bundle.hidden = hasOffer || bundleMatches.length < 2;

      if (tableTarget) {
        var rows = [
          ["Price", "price"],
          ["Format", "format"],
          ["Best for", "description"],
          ["What’s included", "includes"],
          ["Details needed", "requirements"],
          ["Delivery", "delivery"]
        ];
        var cartAddUrl = safeCartPath(dialog.dataset.cartAddUrl, "/cart/add");
        var cartUrl = safeCartPath(dialog.dataset.cartUrl, "/cart");
        var availableOptions = [];
        if (comparisonCatalog) {
          availableOptions = Array.prototype.slice.call(comparisonCatalog.options).filter(function (option) {
            return option.value && selectedIndex(option.value) === -1;
          });
        }
        var columns = selectedItems.slice();
        if (columns.length < maximumItems) columns.push(null);

        function actionMarkup(item, position) {
          var isTop = position === "top";
          var actionClass = isTop ? "product-comparison-text-action" : "button button-gold";
          var actionContent = isTop ? "Add to cart" : '<span class="button-icon"><svg aria-hidden="true" fill="none" viewBox="0 0 20 20"><path d="M5.5 7h9l-.7 8H6.2l-.7-8Z" stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"/><path d="M7.5 8V5.5a2.5 2.5 0 0 1 5 0V8" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/></svg></span><span>Add to cart</span>';
          if (item.enquiryOnly) {
            return '<a class="' + actionClass + '" href="' + escapeComparisonHtml(item.url + '#booking-enquiry') + '">Send an enquiry</a>';
          } else if (item.available && item.variantId && !item.requiresDetails) {
            return '<form action="' + escapeComparisonHtml(cartAddUrl) + '" class="product-comparison-add-form" method="post"><input name="id" type="hidden" value="' + escapeComparisonHtml(item.variantId) + '"><input name="quantity" type="hidden" value="1"><input name="return_to" type="hidden" value="' + escapeComparisonHtml(cartUrl) + '"><button class="' + actionClass + '" type="submit">' + actionContent + '</button></form>';
          } else if (item.available) {
            var formAnchor = item.handle === "character-analysis-free-transits-draconic-analysis"
              ? "#special-offer-order"
              : item.handle === "patrick-consultation" ? "#booking-enquiry" : "#product-form";
            return '<a class="' + actionClass + '" href="' + escapeComparisonHtml(item.url + formAnchor) + '">' + actionContent + '</a>';
          } else {
            return '<a class="' + (isTop ? 'product-comparison-text-action' : 'button button-outline') + '" href="' + escapeComparisonHtml(item.url) + '">View options</a>';
          }
        }

        var optionMarkup = '<option value="">Choose a product</option>' + availableOptions.map(function (option) {
          return '<option value="' + escapeComparisonHtml(option.value) + '">' + escapeComparisonHtml(option.textContent) + '</option>';
        }).join("");
        var head = columns.map(function (item, index) {
          if (!item) {
            return '<th class="product-comparison-picker-heading" scope="col"><span>Choice ' + (index + 1) + '</span><strong>Add another product</strong><select data-comparison-picker aria-label="Choose product for comparison column ' + (index + 1) + '">' + optionMarkup + '</select></th>';
          }
          return '<th class="product-comparison-product-heading" scope="col"><button class="product-comparison-table-remove" type="button" data-comparison-remove="' + escapeComparisonHtml(item.handle) + '" aria-label="Remove ' + escapeComparisonHtml(item.title) + ' from comparison" title="Remove from comparison"><svg aria-hidden="true" fill="none" viewBox="0 0 20 20"><path d="M4.5 6h11M8 6V4.5h4V6m2 0-.6 9H6.6L6 6m2.2 2.3.25 4.4m3.35-4.4-.25 4.4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"/></svg></button><span>' + escapeComparisonHtml(item.type) + '</span><strong>' + escapeComparisonHtml(item.title) + '</strong>' + actionMarkup(item, "top") + '</th>';
        }).join("");
        var body = rows.map(function (row) {
          return '<tr><th scope="row">' + escapeComparisonHtml(row[0]) + '</th>' + columns.map(function (item) { return item ? '<td>' + tableCellValue(item, row[1]) + '</td>' : '<td class="product-comparison-empty-cell"><span aria-hidden="true">—</span></td>'; }).join("") + '</tr>';
        }).join("");
        var foot = columns.map(function (item) { return '<td>' + (item ? actionMarkup(item, "bottom") : '') + '</td>'; }).join("");
        tableTarget.innerHTML = '<table class="product-comparison-table" style="min-width:' + (8 + columns.length * 13.5) + 'rem"><caption class="sr-only">Choose and compare up to four products</caption><thead><tr><th scope="col">Compare</th>' + head + '</tr></thead><tbody>' + body + '</tbody><tfoot><tr><th scope="row">Choose</th>' + foot + '</tr></tfoot></table>';
      }

      saveComparisonItems();
    }

    function openComparison(trigger) {
      lastLauncher = trigger || launcher;
      renderComparison();
      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
      var title = dialog.querySelector("#ProductComparisonTitle");
      if (title) title.focus();
    }

    function closeComparison() {
      if (typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
      if (lastLauncher && typeof lastLauncher.focus === "function") lastLauncher.focus();
    }

    document.addEventListener("click", function (event) {
      var addButton = event.target.closest("[data-compare-product]");
      if (addButton) {
        var item = itemFromButton(addButton);
        if (!item) return;
        event.preventDefault();
        var index = selectedIndex(item.handle);
        if (index !== -1) selectedItems.splice(index, 1);
        else if (selectedItems.length < maximumItems) selectedItems.push(item);
        dockDismissed = false;
        saveComparisonItems();
        renderComparison();
        return;
      }

      if (event.target.closest("[data-comparison-dock-close]")) {
        dockDismissed = true;
        dock.hidden = true;
        return;
      }

      var removeButton = event.target.closest("[data-comparison-remove]");
      if (removeButton) {
        var removeIndex = selectedIndex(removeButton.dataset.comparisonRemove || "");
        if (removeIndex !== -1) selectedItems.splice(removeIndex, 1);
        saveComparisonItems();
        renderComparison();
        return;
      }

      if (event.target.closest("[data-comparison-launcher]")) openComparison(event.target.closest("[data-comparison-launcher]"));
      if (event.target.closest("[data-comparison-close]")) closeComparison();
      if (event.target.closest("[data-comparison-clear]")) {
        selectedItems = [];
        saveComparisonItems();
        renderComparison();
      }
    });

    dialog.addEventListener("change", function (event) {
      var picker = event.target.closest("[data-comparison-picker]");
      if (!picker || !comparisonCatalog || selectedItems.length >= maximumItems) return;
      var sourceOption = Array.prototype.slice.call(comparisonCatalog.options).find(function (option) {
        return normaliseComparisonHandle(option.value) === normaliseComparisonHandle(picker.value);
      });
      var item = itemFromPicker(sourceOption);
      if (!item || selectedIndex(item.handle) !== -1) return;
      selectedItems.push(item);
      dockDismissed = false;
      saveComparisonItems();
      renderComparison();
    });

    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) closeComparison();
    });
    function initComparisonVisibility() {
      var regions = [];
      document.querySelectorAll("[data-compare-product]").forEach(function (button) {
        var region = button.closest("section") || button.closest("article") || button;
        if (regions.indexOf(region) === -1) regions.push(region);
      });
      if (!regions.length) {
        productRegionVisible = false;
        renderComparison();
        return;
      }
      if (!("IntersectionObserver" in window)) {
        productRegionVisible = true;
        renderComparison();
        return;
      }
      var visibleRegions = [];
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var index = visibleRegions.indexOf(entry.target);
          if (entry.isIntersecting && index === -1) visibleRegions.push(entry.target);
          if (!entry.isIntersecting && index !== -1) visibleRegions.splice(index, 1);
        });
        productRegionVisible = visibleRegions.length > 0;
        renderComparison();
      }, { rootMargin: "-12% 0px -12% 0px", threshold: 0.04 });
      regions.forEach(function (region) { observer.observe(region); });
    }

    renderComparison();
    initComparisonVisibility();
  }

  function initAccessibilityTools() {
    if (document.documentElement.dataset.paAccessibilityReady === "true") return;
    var widget = document.querySelector("[data-pa-accessibility]");
    if (!widget) return;
    document.documentElement.dataset.paAccessibilityReady = "true";

    var accessibilityStorageKey = "pa-accessibility-settings-v1";
    var legacyStorageKey = "patrick-store-accessibility";
    var defaults = { textScale: 100, contrast: false, links: false, spacing: false, motion: false, plainFont: false };
    var preferences = Object.assign({}, defaults);
    var previousFocus = null;
    var inertedElements = [];

    function normaliseAccessibilityPreferences(value) {
      var candidate = value && typeof value === "object" ? value : {};
      var legacyScale = candidate.text === "large" ? 125 : candidate.text === "x-large" ? 150 : 100;
      var suppliedScale = candidate.textScale !== undefined && candidate.textScale !== null ? Number(candidate.textScale) : legacyScale;
      var validScale = Number.isFinite(suppliedScale) ? suppliedScale : 100;
      return {
        textScale: Math.min(200, Math.max(100, Math.round(validScale / 5) * 5)),
        contrast: candidate.contrast === true,
        links: candidate.links === true,
        spacing: candidate.spacing === true,
        motion: candidate.motion === true,
        plainFont: candidate.plainFont === true
      };
    }

    try {
      preferences = normaliseAccessibilityPreferences(JSON.parse(localStorage.getItem(accessibilityStorageKey) || localStorage.getItem(legacyStorageKey) || "{}"));
    } catch (error) {}

    function saveAccessibilityPreferences() {
      try { localStorage.setItem(accessibilityStorageKey, JSON.stringify(preferences)); } catch (error) {}
    }

    function changedAccessibilityCount() {
      return Object.keys(defaults).reduce(function (count, key) { return count + (preferences[key] !== defaults[key] ? 1 : 0); }, 0);
    }

    function updateAccessibilityControls() {
      widget.querySelectorAll("[data-pa-a11y-text-preset]").forEach(function (button) {
        button.setAttribute("aria-pressed", Number(button.dataset.paA11yTextPreset) === preferences.textScale ? "true" : "false");
      });
      var range = widget.querySelector("[data-pa-a11y-text-range]");
      var output = widget.querySelector("[data-pa-a11y-text-output]");
      if (range) {
        range.value = String(preferences.textScale);
        range.setAttribute("aria-valuetext", preferences.textScale + "% text size");
        range.style.setProperty("--pa-a11y-range-progress", (preferences.textScale - 100) + "%");
      }
      if (output) {
        output.value = preferences.textScale + "%";
        output.textContent = preferences.textScale + "%";
      }
      widget.querySelectorAll("[data-pa-a11y-setting]").forEach(function (button) {
        button.setAttribute("aria-pressed", preferences[button.dataset.paA11ySetting] ? "true" : "false");
      });
      var trigger = widget.querySelector("[data-pa-a11y-open]");
      var badge = widget.querySelector("[data-pa-a11y-change-count]");
      var count = changedAccessibilityCount();
      if (badge) {
        badge.hidden = count === 0;
        badge.textContent = String(count);
      }
      if (trigger) {
        var action = trigger.getAttribute("aria-expanded") === "true" ? "Close" : "Open";
        trigger.dataset.label = count ? "Accessibility options · " + count + " changed" : "Accessibility options";
        trigger.setAttribute("aria-label", action + " accessibility options" + (count ? ", " + count + " " + (count === 1 ? "setting" : "settings") + " changed" : ""));
      }
    }

    function applyAccessibilityPreferences(shouldAnnounce) {
      var root = document.documentElement;
      root.dataset.paA11yTextScale = String(preferences.textScale);
      root.style.setProperty("--pa-a11y-text-scale", preferences.textScale + "%");
      root.style.setProperty("--pa-a11y-text-factor", String(preferences.textScale / 100));
      root.classList.toggle("pa-a11y-text-enlarged", preferences.textScale > 100);
      root.classList.toggle("pa-a11y-text-reflow", preferences.textScale >= 150);
      root.classList.toggle("pa-a11y-text-high", preferences.textScale >= 175);
      root.classList.toggle("pa-a11y-text-max", preferences.textScale >= 200);
      root.classList.toggle("pa-a11y-contrast", preferences.contrast);
      root.classList.toggle("pa-a11y-links", preferences.links);
      root.classList.toggle("pa-a11y-text-spacing", preferences.spacing);
      root.classList.toggle("pa-a11y-reduce-motion", preferences.motion);
      root.classList.toggle("pa-a11y-plain-font", preferences.plainFont);
      updateAccessibilityControls();
      if (shouldAnnounce) {
        var status = widget.querySelector("[data-pa-a11y-status]");
        if (status) {
          status.textContent = "";
          requestAnimationFrame(function () { status.textContent = "Accessibility display preferences updated."; });
        }
      }
    }

    function setBackgroundInert(inert) {
      if (!("inert" in HTMLElement.prototype)) return;
      if (inert) {
        inertedElements = Array.from(document.body.children).filter(function (element) { return element !== widget && element.tagName !== "SCRIPT"; }).map(function (element) {
          var wasInert = element.inert;
          element.inert = true;
          return { element: element, wasInert: wasInert };
        });
      } else {
        inertedElements.forEach(function (entry) { entry.element.inert = entry.wasInert; });
        inertedElements = [];
      }
    }

    function openAccessibilityDrawer() {
      previousFocus = document.activeElement;
      widget.classList.add("is-open");
      document.documentElement.classList.add("pa-a11y-open");
      widget.querySelector("[data-pa-a11y-open]").setAttribute("aria-expanded", "true");
      widget.querySelector("[data-pa-a11y-layer]").setAttribute("aria-hidden", "false");
      updateAccessibilityControls();
      setBackgroundInert(true);
      requestAnimationFrame(function () { widget.querySelector("[data-pa-a11y-close]").focus({ preventScroll: true }); });
    }

    function closeAccessibilityDrawer() {
      var trigger = widget.querySelector("[data-pa-a11y-open]");
      widget.classList.remove("is-open");
      document.documentElement.classList.remove("pa-a11y-open");
      trigger.setAttribute("aria-expanded", "false");
      widget.querySelector("[data-pa-a11y-layer]").setAttribute("aria-hidden", "true");
      updateAccessibilityControls();
      setBackgroundInert(false);
      var focusTarget = previousFocus && typeof previousFocus.focus === "function" ? previousFocus : trigger;
      focusTarget.focus({ preventScroll: true });
      previousFocus = null;
    }

    widget.addEventListener("click", function (event) {
      var preset = event.target.closest("[data-pa-a11y-text-preset]");
      var setting = event.target.closest("[data-pa-a11y-setting]");
      if (event.target.closest("[data-pa-a11y-open]")) {
        if (widget.classList.contains("is-open")) closeAccessibilityDrawer();
        else openAccessibilityDrawer();
      } else if (event.target.closest("[data-pa-a11y-close], [data-pa-a11y-overlay]")) {
        closeAccessibilityDrawer();
      } else if (preset) {
        preferences.textScale = Number(preset.dataset.paA11yTextPreset);
        saveAccessibilityPreferences();
        applyAccessibilityPreferences(true);
      } else if (setting) {
        var key = setting.dataset.paA11ySetting;
        preferences[key] = !preferences[key];
        saveAccessibilityPreferences();
        applyAccessibilityPreferences(true);
      } else if (event.target.closest("[data-pa-a11y-reset]")) {
        preferences = Object.assign({}, defaults);
        saveAccessibilityPreferences();
        applyAccessibilityPreferences(true);
      }
    });

    var textRange = widget.querySelector("[data-pa-a11y-text-range]");
    if (textRange) textRange.addEventListener("input", function () {
      preferences.textScale = Math.min(200, Math.max(100, Math.round(Number(textRange.value) / 5) * 5));
      saveAccessibilityPreferences();
      applyAccessibilityPreferences(false);
    });

    document.addEventListener("keydown", function (event) {
      if (!widget.classList.contains("is-open")) return;
      if (event.key === "Escape") {
        event.preventDefault();
        closeAccessibilityDrawer();
        return;
      }
      if (event.key !== "Tab") return;
      var panel = widget.querySelector(".pa-a11y__panel");
      var focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) { return !element.hidden; });
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    saveAccessibilityPreferences();
    applyAccessibilityPreferences(false);
  }

  function initTestimonialArchives(scope) {
    var root = scope || document;
    var archives = [];
    if (root.matches && root.matches("[data-testimonials-archive]")) archives.push(root);
    root.querySelectorAll("[data-testimonials-archive]").forEach(function (archive) { archives.push(archive); });

    archives.forEach(function (archive) {
      if (archive.dataset.paTestimonialsReady === "true") return;
      archive.dataset.paTestimonialsReady = "true";

      var cards = Array.from(archive.querySelectorAll("[data-testimonial-card]"));
      var productCards = Array.from(archive.querySelectorAll("[data-testimonial-product]"));
      var filters = Array.from(archive.querySelectorAll("[data-testimonial-filter]"));
      var more = archive.querySelector("[data-testimonial-more]");
      var status = archive.querySelector("[data-testimonial-status]");
      var activeCategory = "all";
      var visibleCount = 12;

      function update() {
        var matches = cards.filter(function (card) {
          return activeCategory === "all" || card.dataset.testimonialCategory === activeCategory;
        });

        cards.forEach(function (card) {
          var categoryMatches = activeCategory === "all" || card.dataset.testimonialCategory === activeCategory;
          var position = categoryMatches ? matches.indexOf(card) : -1;
          card.hidden = !categoryMatches || position >= visibleCount;
        });

        productCards.forEach(function (card) {
          card.hidden = activeCategory !== "all" && card.dataset.testimonialCategory !== activeCategory;
        });

        filters.forEach(function (filter) {
          var selected = filter.dataset.testimonialFilter === activeCategory;
          filter.classList.toggle("is-active", selected);
          filter.setAttribute("aria-pressed", selected ? "true" : "false");
        });

        var shown = Math.min(visibleCount, matches.length);
        if (status) status.textContent = "Showing " + shown + " of " + matches.length + (matches.length === 1 ? " testimonial" : " testimonials");
        if (more) {
          more.hidden = shown >= matches.length;
          more.textContent = "Show " + Math.min(12, matches.length - shown) + " more";
        }
      }

      filters.forEach(function (filter) {
        filter.addEventListener("click", function () {
          activeCategory = filter.dataset.testimonialFilter || "all";
          visibleCount = 12;
          update();
        });
      });

      if (more) more.addEventListener("click", function () {
        visibleCount += 12;
        update();
      });

      update();
    });
  }

  function initShopifyEditorEvents() {
    document.addEventListener("shopify:section:load", function (event) {
      initTheme(event.target);
      initExternalVideos(event.target);
      initMenu(event.target);
      initHeroCarousels(event.target);
      initFinder(event.target);
      initEnquiryHighlight(event.target);
      initReaderServiceChoices(event.target);
      initHoraryQuestionExamples(event.target);
      initReaderOfferingJumps(event.target);
      initReaderFilters(event.target);
      initReadingComparisonScroll(event.target);
      initTestimonialCarousels(event.target);
      initCatalogueFilters(event.target);
      initReportFilters(event.target);
      initReaderSessionPickers(event.target);
      initLoveReportBundles(event.target);
      initLoveReportHeroCards(event.target);
      initAjaxCart(event.target);
      initCartGiftOptions(event.target);
      initCartLoveOffers(event.target);
      initGiftRecipientForms(event.target);
      initCartRecipientModes(event.target);
      initFocusSuggestionChips(event.target);
      initTimePickers(event.target);
      initReportRecipientForms(event.target);
      initCartDetailsModals(event.target);
      initTestimonialArchives(event.target);
      initProductComparison();
      initAccessibilityTools();
    });

    document.addEventListener("shopify:block:select", function (event) {
      initTheme(event.target);
      initExternalVideos(event.target);
      initMenu(event.target);
      initHeroCarousels(event.target);
      var heroSlide = event.target.closest && event.target.closest("[data-hero-slide]");
      var heroCarousel = heroSlide && heroSlide.closest("[data-hero-carousel]");
      if (heroCarousel && heroCarousel._paShowHeroSlide) {
        var heroSlides = Array.from(heroCarousel.querySelectorAll("[data-hero-slide]"));
        heroCarousel._paShowHeroSlide(heroSlides.indexOf(heroSlide), false);
      }
      var menu = event.target.closest && event.target.closest("[data-store-menu]");
      if (menu && menu._paOpenMenu) {
        var panel = event.target.closest(".store-menu-group-panel");
        if (panel) {
          panel.hidden = false;
          var toggle = menu.querySelector("[aria-controls='" + panel.id + "']");
          if (toggle) {
            toggle.setAttribute("aria-expanded", "true");
            toggle.querySelector("[aria-hidden='true']").textContent = "-";
          }
        }
        menu._paOpenMenu();
      }
      initFinder(event.target);
      initHoraryQuestionExamples(event.target);
      initReaderOfferingJumps(event.target);
      initReaderFilters(event.target);
      initReadingComparisonScroll(event.target);
      initTestimonialCarousels(event.target);
      initCatalogueFilters(event.target);
      initReportFilters(event.target);
      initReaderSessionPickers(event.target);
      initLoveReportBundles(event.target);
      initLoveReportHeroCards(event.target);
      initAjaxCart(event.target);
      initCartGiftOptions(event.target);
      initCartLoveOffers(event.target);
      initGiftRecipientForms(event.target);
      initCartRecipientModes(event.target);
      initFocusSuggestionChips(event.target);
      initTimePickers(event.target);
      initReportRecipientForms(event.target);
      initCartDetailsModals(event.target);
      initTestimonialArchives(event.target);
      initProductComparison();
      initAccessibilityTools();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initTheme();
    initExternalVideos();
    initHeader();
    initMenu();
    initMenuKeyboardClose();
    initHeroCarousels();
    initFinder();
    initEnquiryHighlight();
    initReaderServiceChoices();
    initHoraryQuestionExamples();
    initReaderOfferingJumps();
    initReaderFilters();
    initReadingComparisonScroll();
    initTestimonialCarousels();
    initCatalogueFilters();
    initReportFilters();
    initReaderSessionPickers();
    initReadingTabs();
    initTarotPicker();
    initConsultationBooking();
    initLoveReportBundles();
    initLoveReportHeroCards();
    initAjaxCart();
    initCartGiftOptions();
    initCartLoveOffers();
    initGiftRecipientForms();
    initCartRecipientModes();
    initFocusSuggestionChips();
    initTimePickers();
    initReportRecipientForms();
    initCartDetailsModals();
    initTestimonialArchives();
    initProductComparison();
    initAccessibilityTools();
    initShopifyEditorEvents();
  });
})();
